import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ZoomDropdown from "../components/ZoomDropdown";
import logo from "../assets/logo.png";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Grid2,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  fabClasses,
  Divider,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import SignatureModalContent from "../components/SignatureModalContent";
import { format, parse, isValid } from "date-fns";
import FileUpload from "../components/FileUpload";
import "../styles/App.styles.css";
import "../App.css";
import { Rnd } from "react-rnd";
import TabsComponent from "../components/TabsComponent";
import ForYou from "../components/ForYou";
import ForOthers from "../components/ForOthers";
import TextPropertiesPanel from "../components/TextPropertiesPanel";
import DatePickerComponent from "../components/DatePickerComponent";
import EditIcon from "@mui/icons-material/Edit";
import ImageCropperModal from "../components/ImageCropperModal";
import AddIcon from "@mui/icons-material/Add";
import SignersDialog from "../components/SignersDialog";
import SignerFieldProperties from "../components/SignerFieldProperty";
import {
  downloadOriginalPdf,
  getColorWithNewOpacity,
  getSignerBoxContent,
  getSignerBoxContentSvg,
  handleDownloadPDFHereTemp,
  hashIds,
  saveData,
  saveDataTemplat,
  unhashIds,
} from "../components/utlis";
import {
  FrontendBaseUrl,
  getUserLocation,
  post,
  postFormData,
} from "../apis/apis";
import DropdownPropertiesPanel from "../components/DropdownPropertiesPanel";
import toastAlert from "../components/toastAlert";
import getActivityLogUserFiles from "../components/getActivityLogUserFiles";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { useAsyncValue } from "react-router-dom";
import getActivityLogUserTemp from "../components/MaintainActivityLogTemplate";
import SignersDialogTemplate from "../components/SignersDialogTemplate";
import EsignEditorTour from "../components/EsignEditorTour";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

function EsignSetupTemplate() {
  const [showTour, setShowTour] = useState(false);
  const [isReadyForTour, setIsReadyForTour] = useState(false);
  const [textFieldHistory, setTextFieldHistory] = useState({});
  const [activePage, setActivePage] = useState(1); // Track active page
  const [SendTemplateModalConfirmation, setSendTemplateModalConfirmation] =
    useState(false);
  const [saveConfirmModalOpen, setSaveConfirmModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const handleConfirm1 = () => {
    setLoading1(true);
  };
  const [pageSizes, setPageSizes] = useState({});
  const [globalIsRequired, setGlobalIsRequired] = useState(true);
  const [textFieldMetrics, setTextFieldMetrics] = useState({
    width: 120,
    height: 30,
  });
  const [annotationSettings, setAnnotationSettings] = useState({
    my_text: {
      fontSize: 21,
      fontFamily: "Helvetica",
      color: "#000000",
      format: [],
      letterSpacing: 0,
      alignment: "left",
      opacity: 1,
      width: 120,
      height: 30,
    },
    signer_text: {
      fontSize: 21,
      fontFamily: "Helvetica",
      isRequired: false,
      width: 60,
      height: 30,
    },
    signer_initials: {
      isRequired: false,
      width: 250,
      height: 100,
    },
    signer_initials_text: {
      isRequired: false,
      width: 100,
      height: 100,
    },
    signer_date: {
      isRequired: false,
      dateFormat: "MMM dd, yyyy",
      width: 150,
      height: 30,
    },
    signer_checkmark: {
      isRequired: false,
      width: 30,
      height: 30,
    },
    signer_dropdown: {
      isRequired: false,
      options: [],
      width: 150,
      height: 30,
    },
  });
  // Add new state at the top of App component
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [loadingStamps, setLoadingStamps] = useState({});

  const [pageNoClicked, setPageNoClicked] = useState(null);
  const styles = {
    sidebarStyle: {
      cursor: "default !important",
      "& *": {
        cursor: "default !important",
      },
      "& button": {
        cursor: "pointer !important",
      },
      "& .thumbnail-container": {
        cursor: "pointer !important",
      },
    },
  };

  // // Add debounce utility function
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // check

  useEffect(() => {
    const pdfContainer = pdfContainerRef.current;
    if (!pdfContainer) return;

    const handleScroll = debounce((e) => {
      const container = e.target;
      const containerRect = container.getBoundingClientRect();
      const elements = document.querySelectorAll(".pdf-page-container");

      let detectedPage = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isVisible =
          rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

        if (isVisible && !detectedPage) {
          detectedPage = parseInt(element.id.split("-")[1]);
        }
      });

      if (detectedPage) {
        setActivePage(detectedPage);
      }
    }, 16); // 60fps debounce

    pdfContainer.addEventListener("scroll", handleScroll);
    return () => pdfContainer.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollThumbnailIntoView = (pageNum) => {
    const thumbnailElement = document.getElementById(`thumbnail-${pageNum}`);

    if (thumbnailElement && sidebarRef.current) {
      thumbnailElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
  useEffect(() => {
    // if (sidebarVisible) {
    scrollThumbnailIntoView(activePage);
    // }
  }, [activePage]);

  const handlePageHover = (pageNum) => {
    setActivePage(pageNum); // Nothing else!
  };

  // endf
  const handleEditSigner = (signer, event) => {
    event.stopPropagation(); // Prevent dropdown from closing
    setSignersDialogOpen(true);
    // You'll need to add logic in SignersDialog to handle editing mode
    // Pass the signer to edit through props
    const signerIndex = signers.findIndex((s) => s.id === signer.id);
    setSignerToEdit({ signer, index: signerIndex }); // Add this state
  };
  const colortheme = "rgb(35, 179, 232)";
  const [pdfFile, setPdfFile] = useState(null);
  const [scale, setScale] = useState(1); // Changed initial scale to 0.8
  const [pdfImages, setPdfImages] = useState([]);
  useEffect(() => {
    const updatePageSizes = () => {
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    };

    updatePageSizes();

    window.addEventListener("resize", updatePageSizes);
    return () => window.removeEventListener("resize", updatePageSizes);
  }, [pdfImages, scale]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [firstPageHeight, setFirstPageHeight] = useState(null);
  // At the top with other state declarations
  const [annotationType, setAnnotationType] = useState(null); // 'text' or 'image'
  // Modify the annotations state to store per-page annotations
  const [annotations, setAnnotations] = useState({}); // Changed from array to object with page keys
  const [isAnnotating, setIsAnnotating] = useState(false);
  const [focusedAnnotation, setFocusedAnnotation] = useState(null);
  const [active, setActive] = useState("2");
  const [selectedSigner, setSelectedSigner] = useState([]);
  // First, add a state for storing click position
  const [stampClickPosition, setStampClickPosition] = useState(null);
  // Add this state in your App component
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signers, setSigners] = useState([]);
  // Inside your App.js, add this state
  const [selectedSignerId, setSelectedSignerId] = useState(null);
  // Add these helper functions

  // Add these states in your App component
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const getTypeListItem = (type) => {
    setIsAnnotating(true);
    setAnnotationType(type);
  };

  const [initialsBox, setInitialBox] = useState(false);
  const pdfContainerRef = useRef(null);
  const sidebarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const getSignerColorById = (signerId, signers) => {
    const signer = signers.find(
      (s) => s.signer_id === signerId || s.id === signerId
    );
    return signer?.color || "rgba(0, 0, 0, 0.1)"; // Default color if signer not found
  };
  // Add this component inside your EsignSetupTemplate component
  const FullScreenLoader = () => (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(3, 3, 3, 0.8)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "rgb(35, 179, 232)",
          marginBottom: 2,
        }}
      />
      <Typography variant="h6" color="textSecondary" style={{ color: "white" }}>
        Loading Document...
      </Typography>
    </Box>
  );

  // Add new state at the top of your App component
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const annotationRefs = useRef({}); // Store refs for each annotation
  const cursorRef = useRef(null);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [activeAnnotationId, setActiveAnnotationId] = useState(null);

  const textAnnotationTypes = ["my_text", "signer_text", "date"];
  // states
  const [fileName, setFileName] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [securedShare, setSecuredShare] = useState(false);
  const [statusFile, setStatusFile] = useState("");
  const [uniqIdDoc, setUniqIdDoc] = useState("");

  const isTextAnnotation = textAnnotationTypes?.includes(annotationType);
  const selectedAnnotationType =
    textAnnotationTypes.includes(selectedAnnotation);
  const [stampInputRef] = useState(React.createRef());
  // Add these states at the top of your App component
  const [cropperModalOpen, setCropperModalOpen] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [pendingStampAction, setPendingStampAction] = useState(null);

  // const handleStampFileSelect = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     setCropSrc(e.target.result);
  //     setPendingStampAction({
  //       isEdit: !!editingAnnotation,
  //       editData: editingAnnotation,
  //       newStampPosition: stampClickPosition,
  //     });
  //     setCropperModalOpen(true);
  //   };
  //   reader.readAsDataURL(file);
  //   event.target.value = "";
  // };
  const handleStampFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Create temporary loading annotation
    if (pageNoClicked && stampClickPosition) {
      const tempAnnotation = {
        id: Date.now(),
        x: stampClickPosition.x,
        y: stampClickPosition.y,
        type: "stamp",
        // width: 150 / scale,
        // height: 150 / scale,
        width: stampClickPosition.width,
        height: stampClickPosition.height,
        isLoading: true,
        page_no: pageNoClicked,
      };

      // Add temporary annotation with loader
      setAnnotations((prev) => ({
        ...prev,
        [pageNoClicked]: [...(prev[pageNoClicked] || []), tempAnnotation],
      }));
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSrc(e.target.result);
      setPendingStampAction({
        isEdit: !!editingAnnotation,
        editData: editingAnnotation,
        newStampPosition: stampClickPosition,
      });
      setCropperModalOpen(true);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };
  // Add handler for cropped image
  const handleCroppedStamp1 = (croppedImage) => {
    const img = new Image();
    img.onload = () => {
      const defaultWidth = 150;
      const aspectRatio = img.width / img.height;
      const defaultHeight = defaultWidth / aspectRatio;

      if (pendingStampAction.isEdit) {
        // Handle editing existing stamp
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const { pageNum, index } = pendingStampAction.editData;

          const existingAnnot = updatedAnnotations[pageNum][index];
          updatedAnnotations[pageNum][index] = {
            ...existingAnnot,
            imageUrl: croppedImage,
            height: existingAnnot.width / aspectRatio,
          };

          return updatedAnnotations;
        });
        setEditingAnnotation(null);
      } else {
        // Handle new stamp creation
        const newAnnotation = {
          id: Date.now(),
          x: pendingStampAction.newStampPosition.x,
          y: pendingStampAction.newStampPosition.y,
          type: "stamp",
          page_no: pageNoClicked,
          imageUrl: croppedImage,
          width: defaultWidth / scale,
          height: defaultHeight / scale,
        };

        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          const newIndex = updatedAnnotations[activePage].length - 1;
          setActiveAnnotation(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      }

      // Reset states
      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    };
    img.src = croppedImage;
  };
  // Update handleCroppedStamp function
  const handleCroppedStamp = async (croppedImage) => {
    try {
      // Upload cropped image
      const base64Response = await fetch(croppedImage);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "stamp.png", { type: "image/png" });

      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading stamp");
        return;
      }

      const ImageUrl = apiData.public_url;

      if (pendingStampAction.isEdit) {
        // Handle editing existing stamp
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const { pageNum, index } = pendingStampAction.editData;

          const existingAnnot = updatedAnnotations[pageNum][index];
          updatedAnnotations[pageNum][index] = {
            ...existingAnnot,
            imageUrl: ImageUrl,
            isLoading: false,
          };

          return updatedAnnotations;
        });
      } else {
        // Handle new stamp
        setAnnotations((prev) => {
          const pageAnnotations = prev[pageNoClicked] || [];
          const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

          if (loadingIndex !== -1) {
            const newAnnotations = [...pageAnnotations];
            newAnnotations[loadingIndex] = {
              ...newAnnotations[loadingIndex],
              imageUrl: ImageUrl,
              isLoading: false,
            };

            return {
              ...prev,
              [pageNoClicked]: newAnnotations,
            };
          }

          return prev;
        });
      }

      // Reset states
      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    } catch (error) {
      console.error("Error handling stamp:", error);
      toastAlert("error", "Error uploading stamp");

      // Clean up loading annotation on error
      setAnnotations((prev) => {
        const pageAnnotations = prev[pageNoClicked] || [];
        return {
          ...prev,
          [pageNoClicked]: pageAnnotations.filter((a) => !a.isLoading),
        };
      });
    }
  };
  const calculateZoomPercentage = useCallback((scaleValue) => {
    // return Math.round((scaleValue / 0.8) * 100);
    return Math.round(scaleValue * 100);
  }, []);

  const calculateImageWidth = useCallback((scaleValue) => {
    // Use a fixed maximum width approach instead of viewport-dependent scaling
    const containerWidth =
      pdfContainerRef.current?.offsetWidth || window.innerWidth * 0.8;
    const maxPdfWidth = containerWidth * 0.95; // 95% of container width

    // Base PDF width should be consistent
    const basePdfWidth = Math.min(800, maxPdfWidth); // Max 800px base width

    // Apply scale factor
    const scaledWidth = basePdfWidth * scaleValue;

    // Convert to percentage of container
    return Math.min(95, (scaledWidth / containerWidth) * 100);
  }, []);
  // Memoize container width update
  const updateContainerWidth = useCallback(() => {
    if (pdfContainerRef.current) {
      setContainerWidth(pdfContainerRef.current.offsetWidth);
    }
  }, []);
  // Add these constants at the top of your file
  const RESIZE_HANDLES = {
    // bottom: true,
    // bottomLeft: true,
    bottomRight: true,
    // left: true,
    // right: true,
    // top: true,
    // topLeft: true,
    // topRight: true,
  };

  // Combine container width and resize effects
  useEffect(() => {
    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => window.removeEventListener("resize", updateContainerWidth);
  }, [updateContainerWidth, scale]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedAnnotation(null);
        setAnnotationType(null);
        setIsAnnotating(false);
      }
    };

    // Add event listener when the component mounts
    document.body.addEventListener("keydown", handleKeyDown);

    // Remove event listener when the component unmounts
    return () => {
      document.body.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const loadPdfFromUrl = async (url, token = null) => {
    console.log("=== LOAD PDF FROM URL START ===");
    console.log("URL:", url);
    console.log("Token provided:", token ? 'Yes' : 'No');
    console.log("AuthToken from state:", authToken ? 'Yes' : 'No');

    try {
      // Check if this is an encrypted view URL
      const isEncryptedView = url.includes('link.requiresign.com/api/encrypted-view');
      console.log("Is encrypted view URL?", isEncryptedView);

      const fetchOptions = {
        method: 'GET',
        // Don't use credentials: 'include' when backend uses Access-Control-Allow-Origin: *
        // We're using Authorization header instead, so credentials aren't needed
      };

      // Add headers for encrypted view URL
      if (isEncryptedView) {
        fetchOptions.headers = {
          'Accept': 'application/pdf, */*',
        };

        // Use token parameter if provided, otherwise try state, then localStorage
        let tokenToUse = token || authToken;
        if (!tokenToUse) {
          try {
            const userData = localStorage.getItem('user_data');
            if (userData) {
              // Try to parse and get token (similar to portal)
              const parsed = JSON.parse(userData);
              tokenToUse = parsed?.token;
              console.log("Token retrieved from localStorage:", tokenToUse ? 'Yes' : 'No');
            }
          } catch (e) {
            console.log('No auth token found in localStorage');
          }
        }

        if (tokenToUse) {
          fetchOptions.headers['Authorization'] = `Bearer ${tokenToUse}`;
          console.log('Using auth token for encrypted view');
        } else {
          console.warn('No auth token available for encrypted view URL');
        }

        console.log('Fetch options for encrypted view:', {
          url,
          method: fetchOptions.method,
          hasAuth: !!tokenToUse,
          headers: Object.keys(fetchOptions.headers || {})
        });
      }

      console.log('Fetching URL:', url);
      console.log('Fetch options:', JSON.stringify(fetchOptions, null, 2));
      const response = await fetch(url, fetchOptions);
      console.log('Response status:', response.status, response.statusText);
      console.log('Response ok:', response.ok);

      // Get content type first
      const contentType = response.headers.get('content-type');
      console.log('Response content-type:', contentType);
      console.log('All response headers:', Object.fromEntries(response.headers.entries()));

      // If we get HTML, it's likely an error page - read it to see the error
      if (contentType && contentType.includes('text/html')) {
        const errorText = await response.text();
        console.error('Got HTML response instead of PDF. Status:', response.status);
        console.error('HTML content (first 1000 chars):', errorText.substring(0, 1000));

        // Try to extract error message from HTML if it's a JSON error
        try {
          const jsonMatch = errorText.match(/\{[\s\S]*"error"[\s\S]*\}/);
          if (jsonMatch) {
            const errorJson = JSON.parse(jsonMatch[0]);
            throw new Error(`Backend error: ${errorJson.message || 'Unknown error'}`);
          }
        } catch (e) {
          // Not JSON, check for common error patterns
          if (errorText.includes('401') || errorText.includes('Unauthorized')) {
            throw new Error('Authentication failed. Please check if auth token is valid.');
          }
          if (errorText.includes('404') || errorText.includes('Not Found')) {
            throw new Error('File not found. The encrypted file ID may be invalid.');
          }
          if (errorText.includes('403') || errorText.includes('Forbidden')) {
            throw new Error('Access forbidden. You may not have permission to view this file.');
          }
        }

        throw new Error(`Received HTML instead of PDF. Status: ${response.status}. The endpoint may require authentication or the file may not exist.`);
      }

      // Check if response is OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', response.status, errorText);
        throw new Error(`Failed to load PDF: ${response.status} ${response.statusText}`);
      }

      if (!contentType || !contentType.includes('application/pdf')) {
        // Clone response to read text without consuming the original
        const clonedResponse = response.clone();
        const text = await clonedResponse.text();
        console.error('Expected PDF but got:', contentType, text.substring(0, 200));
        throw new Error('Response is not a PDF. Content-Type: ' + contentType);
      }

      const pdfBlob = await response.blob();
      console.log("PDF Blob received:", {
        size: pdfBlob.size,
        type: pdfBlob.type
      });
      setPdfFile(pdfBlob);
      console.log("PDF file set in state");
      console.log("Converting PDF to images...");
      await convertPdfToImages(pdfBlob);
      console.log("=== LOAD PDF FROM URL SUCCESS ===");
    } catch (error) {
      console.error("=== LOAD PDF FROM URL ERROR ===");
      console.error("Error loading PDF from URL:", error);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      setIsLoading(false);
      toastAlert("error", `Failed to load PDF: ${error.message}`);
      // Re-throw error so caller can handle fallback
      throw error;
    }
  };
  const saveDataSigning = async (filteredTextItems) => {
    // setUnsavedChanges(false);
    console.log("file_id");

    const location = await getUserLocation();

    // setsaveLoading(true);
    const postData = {
      template_id: documentId,
      // position_array: savedCanvasData
      position_array: filteredTextItems,
      email_subject: emailSubject,
      email_message: emailMessage,
      created_at_doc: location?.date,
    };
    try {
      const apiData = await post("template/updateTemplatePositions", postData); // Specify the endpoint you want to call
      //console.log('Save Data To canvas ');
      console.log("POSITIONS");

      console.log(apiData);
      if (apiData.error) {
        // setsaveLoading(false);
        // setSaveSuccess(false);
      } else {
        toastAlert("success", "Template saved successfully!");
        // setSaveSuccess(true);
        // setSaveSuccess(false);
        // setsaveLoading(false);

        // fetchDataPositions(file_id);
        // UpdateLastChange();
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
      // setsaveLoading(false);
    }
  };
  const getFunctionTemplateAuditLog = async () => {
    // setImageUrls(apiData.result[0].image);
    // setLoaderResponseFetch1(true);
    // get Images from db
    //console.log(fileId);
    const postData = {
      template_id: documentId,
    };
    const apiData = await post("template/viewTemplateAuditLog", postData); // Specify the endpoint you want to call
    console.log("File Template Fetch Log");

    console.log(apiData);
    // if (apiData.error) {
    //   // toastAlert("error", "No File exist")
    // } else {
    return apiData?.response_data;
    //   // setResponsesTemp(apiData.response_data);
    //   // setSendTemplateResponses1(true);
    //   // setLoaderResponseFetch1(false);
    // }
  };
  const sendToEsignApi = async () => {
    // const data = window.location.pathname.split("/")[2];
    // console.log(data);

    const user_id = userId;
    const email = user_email;
    console.log(documentId);
    let response_log = await getActivityLogUserTemp({
      user_id: user_id,
      file_id: documentId,
      email: email,
      event: "UPLOADED-DOCUMENT",
      response_get: true,
      user_shared_email: email,
      description: `${email} Completed Editing Template ${fileName}`,
    });
    console.log("response_log");

    console.log(response_log);
    const formattedAnnotations = [];

    // Process each page's annotations
    Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
      pageAnnotations.forEach((annot) => {
        // Create a clean annotation object
        const cleanAnnotation = {
          id: annot.id,
          type: annot.type,
          page_no: parseInt(pageNum),
          x: annot.x,
          y: annot.y,
          width: annot.width || 150,
          height: annot.height || 30,
          text: annot.text || null,
          checked: annot.checked || false,
          imageUrl: annot.imageUrl || null,
          format: annot.format || [],
          fontSize: annot.fontSize || 14,
          fontFamily: annot.fontFamily || "Helvetica",
          options: annot.options || [],
          selectedOption: annot.selectedOption || null,
          backgroundColor: annot.backgroundColor || null,
          borderColor: annot.borderColor || null,
          signerId: annot.signerId || null,
          signerColor: annot.signerColor || null,
          isRequired: annot.isRequired || false,
        };

        formattedAnnotations.push(cleanAnnotation);
      });
    });
    console.log("formattedAnnotations", formattedAnnotations);
    let textItems = formattedAnnotations;
    // if (response_log === true) {
    //   console.log("MAINTAIN LOG SUCCESS");
    // } else {
    //   console.log("MAINTAIN ERROR LOG");
    // }
    // let data = await saveData(file_id, annotations, true);

    const cleanedTextItems = textItems.filter(
      (item) =>
        !(
          item.type === "signer_dropdown" &&
          (!item.options || item.options.length === 0)
        )
    );
    console.log("dropdown", cleanedTextItems);
    const specifiedTypes = [
      "my_text",
      "my_signature",
      "my_initials",
      "date",
      "checkmark",
      "highlight",
      "stamp",
    ];
    const filteredTextItems = cleanedTextItems.filter((item) =>
      specifiedTypes.includes(item.type)
    );

    console.log(filteredTextItems);
    const nonSpecifiedTextItems = cleanedTextItems.filter(
      (item) => !specifiedTypes.includes(item.type)
    );
    const groupedAnnotations = {};
    filteredTextItems.forEach((item) => {
      const pageNum = item.page_no;
      if (!groupedAnnotations[pageNum]) {
        groupedAnnotations[pageNum] = [];
      }
      groupedAnnotations[pageNum].push(item);
    });
    // console.log(filteredTextItems);
    // let ActivityLogDetails = await getActivityLog(file_id);
    let ActivityLogDetails = await getFunctionTemplateAuditLog();
    console.log(ActivityLogDetails);
    // setDownloadPdfLoader(false)
    let documentNamedata = fileName;

    // Match multiple `.pdf` at the end
    const pdfPattern = /\.pdf(\.pdf)+$/i;

    if (pdfPattern.test(fileName)) {
      // Remove only the last `.pdf`, keeping the first one
      documentNamedata = fileName.replace(/\.pdf$/i, "");
    }
    const setDownloadPdfLoader = true;
    await handleDownloadPDFHereTemp({
      setDownloadPdfLoader,
      imageUrls: originalPdf,
      textItems: filteredTextItems,
      // textItems,

      canvasWidth: "100%",
      UniqIdDoc: uniqIdDoc,

      ActivityLogData: ActivityLogDetails,
      fileName: documentNamedata,
      file_id: documentId,
      statusData: null,
      imageUrlsCount: null,
      user_id,
    });
    await saveDataSigning(nonSpecifiedTextItems);
    // await saveData();
    // setLoadingSendDocument(false);
    // timeoutn for 1 second
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  // Update the convertPdfToImages function
  const convertPdfToImages = useCallback(async (file) => {
    try {
      let pdfData;
      if (file instanceof Blob) {
        // If file is already a Blob (from file upload)
        pdfData = await file.arrayBuffer();
      } else {
        // If file is a URL
        const response = await fetch(file);
        pdfData = await response.arrayBuffer();
      }

      const loadingTask = pdfjs.getDocument({ data: pdfData });
      const pdf = await loadingTask.promise;
      const images = await Promise.all(
        Array.from({ length: pdf.numPages }, async (_, i) => {
          const page = await pdf.getPage(i + 1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          return canvas.toDataURL("image/png");
        })
      );

      setPdfImages(images);

      // Set loading to false only after images are set and DOM is ready
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    } catch (error) {
      console.error("Error converting PDF:", error);
      setIsLoading(false);
    }
  }, []);
  // hashed
  const [documentId, setDocumentId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  // Function to generate hashed URL
  const generateHashedUrl = (documentId, userId) => {
    const data = { documentId, userId };
    const hashedData = hashIds(data);
    const baseUrl = window.location.origin + window.location.pathname;
    return `${baseUrl}?data=${hashedData}`;
  };

  // Example usage:
  const shareDocument = () => {
    // fileid   user id
    const hashedUrl = generateHashedUrl("116676", "116625");
    // Now you can share this URL
    console.log("Shareable URL:", hashedUrl);
  };
  // funxtions
  const [EditingTemp, setEditingTemp] = useState(false);
  const fetchFileData = async (fileId, user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      template_id: fileId,
      user_id: user_id,
    };
    const apiData = await post("template/viewTemplateForEditor", postData); // Specify the endpoint you want to call
    console.log("File Dta Fetch");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No File exist");
    } else {
      // toastAlert("success", "File exist")
      setFileName(apiData?.result?.file_name || "");

      // Get auth token from localStorage
      let tokenToUse = authToken;
      if (!tokenToUse) {
        try {
          const userData = localStorage.getItem('user_data');
          if (userData) {
            const parsed = JSON.parse(userData);
            tokenToUse = parsed?.token;
            if (tokenToUse) {
              setAuthToken(tokenToUse);
              console.log("Auth token set from localStorage");
            }
          }
        } catch (e) {
          console.log('No auth token found in localStorage');
        }
      }

      let pdfUrl = apiData?.result?.file_url;
      const doc_completed = apiData.result.file_url_completed;

      // Check if file_url is an encrypted download URL and convert it to encrypted view URL
      if (pdfUrl && pdfUrl.includes('/api/encrypted-download/')) {
        // Extract encrypted file ID from URL like "/api/encrypted-download/6341bb35-2e5a-4924-b0e2-f98563f45656"
        const encryptedFileId = pdfUrl.split('/api/encrypted-download/')[1];
        if (encryptedFileId && user_id) {
          // Build encrypted view URL
          pdfUrl = `https://link.requiresign.com/api/encrypted-view/${encryptedFileId}?user_id=${user_id}`;
          console.log("=== CONVERTED TO ENCRYPTED VIEW URL ===");
          console.log("Original URL:", apiData?.result?.file_url);
          console.log("Encrypted File ID:", encryptedFileId);
          console.log("New URL:", pdfUrl);
        }
      }

      if (
        doc_completed === null ||
        doc_completed === undefined ||
        doc_completed === ""
      ) {
        setOriginalPdf(pdfUrl);
        setEditingTemp(true);
      } else {
        setEditingTemp(false);
        // Also check if completed URL is encrypted
        let completedUrl = apiData?.result?.file_url_completed;
        if (completedUrl && completedUrl.includes('/api/encrypted-download/')) {
          const encryptedFileId = completedUrl.split('/api/encrypted-download/')[1];
          if (encryptedFileId && user_id) {
            completedUrl = `https://link.requiresign.com/api/encrypted-view/${encryptedFileId}?user_id=${user_id}`;
            console.log("=== CONVERTED COMPLETED URL TO ENCRYPTED VIEW ===");
            console.log("New completed URL:", completedUrl);
          }
        }
        pdfUrl = completedUrl;
        setOriginalPdf(completedUrl);
      }

      // Load PDF with token
      try {
        await loadPdfFromUrl(pdfUrl, tokenToUse);
      } catch (error) {
        console.error("Failed to load PDF:", error);
        // Error already handled in loadPdfFromUrl with toast
      }

      // end
      //console.log('dfdf');
      //console.log(apiData.result.only_signer);
      setEmailMessage(
        apiData?.result?.email_message ||
        `Please review and e-sign the document\n${apiData?.result?.file_name}\nat your earliest convenience. Thank you!`
      );
      setEmailSubject(apiData?.result?.email_subject || "");
      setUniqIdDoc(apiData?.result?.uniq_id);
      setSigners(apiData.signers);
      setSelectedSigner(apiData.signers[apiData.signers.length - 1]);
      // setSecuredShare(apiData.data.secured_share || false);
      // setSignerFunctionalControls(
      //   apiData.data.signer_functional_controls || true
      // );
      // setSetEsignOrder(apiData.data.esign_order || false);
      // setStatusFile(apiData.data.status || "");
    }
  };
  const [user_email, setUserEmail] = useState("");
  const [user, setUser] = useState(null);
  const [logo, setLogo] = useState(null);
  const [primaryColorComp, setPrimaryColorComp] = useState(null);

  const fetchuser = async (user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      user_id: user_id,
    };
    const apiData = await post("user/getUser1ById", postData); // Specify the endpoint you want to call
    console.log("get user");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No USER exist");
    } else {
      setUserEmail(apiData?.result[0]?.email || "");
      setUser(apiData?.result[0]);
      if (apiData?.companyProfile === null) {
        if (apiData?.result[0]?.logo) {
          setLogo(apiData?.result[0]?.logo);
          console.log("logogogog");
        } else {
          setLogo(null);
          console.log("logo null");
        }
      } else {
        if (apiData?.companyProfile?.company_logo === null) {
          setLogo(null);
        } else {
          setLogo(apiData?.companyProfile?.company_logo);
        }
        if (apiData?.companyProfile?.primary_color === null) {
          setPrimaryColorComp(null);
        } else {
          setPrimaryColorComp(apiData?.companyProfile?.primary_color);
        }
      }
      return apiData;

      // toastAlert("success", "File exist")
    }
  };
  // const UpdateLastChange = async (fileId) => {
  //   const location = await getUserLocation();
  //   const postData = {
  //     file_id: fileId,
  //     last_change: location?.date,
  //   };
  //   try {
  //     const apiData = await post("file/updateLastChange", postData); // Specify the endpoint you want to call
  //     console.log("Update Last Change");

  //     console.log(apiData);
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  // const fetchRecipientsData = async (fileId) => {
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   try {
  //     const apiData = await post("file/getAllRecipientsByFileId", postData); // Specify the endpoint you want to call
  //     //console.log('Recipients');

  //     //console.log(apiData);
  //     if (apiData.error === true || apiData.error === "true") {
  //       setRecipientsData([]);
  //       setCountReceipient(apiData.result.length);
  //     } else {
  //       setRecipientsData(apiData.result);
  //       setCountReceipient(apiData.result.length);
  //     }
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  const fetchSignerData = async (fileId) => {
    const postData = {
      file_id: fileId,
    };
    try {
      const apiData = await post("file/getAllSignersByFileId", postData); // Specify the endpoint you want to call
      console.log("Signers ");

      console.log(apiData);
      if (apiData.error) {
        setSigners([]);
        setSelectedSigner([]);
        setActive("1");
        // setCount(0);
      } else {
        // if(apiData)
        setSigners(apiData.result);
        setSelectedSigner(apiData.result[apiData.result.length - 1]);

        // setSelectedSigner(apiData.result[0]);
        // setCount(apiData.result.length);
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
    }
  };
  // const fetchDataPositions = async (fileId) => {
  //   // get positions from db
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   const apiData = await post("file/getallPositionsFromFile_Id", postData); // Specify the endpoint you want to call
  //   console.log("Position Data");

  //   console.log(apiData);
  //   // if (apiData.error) {
  //   // } else {
  //   //   const positionsData = apiData.result[0]?.position_array;
  //   //console.log('positions');
  //   // console.log(apiData.result);
  //   // const annotationsForDatabase = {
  //   //   1: positionsData,
  //   // };
  //   // setAnnotations(annotationsForDatabase);
  //   if (!apiData.error && apiData.result?.[0]?.position_array) {
  //     const positionsData = apiData.result[0].position_array;

  //     // Parse the JSON string from database
  //     let parsedPositions;
  //     if (typeof positionsData === "string") {
  //       parsedPositions = JSON.parse(positionsData);
  //     } else {
  //       parsedPositions = positionsData;
  //     }

  //     // Group annotations by page number
  //     const groupedAnnotations = {};
  //     parsedPositions.forEach((annotation) => {
  //       const pageNo = annotation.page_no || 1; // Default to page 1 if not specified
  //       if (!groupedAnnotations[pageNo]) {
  //         groupedAnnotations[pageNo] = [];
  //       }
  //       groupedAnnotations[pageNo].push(annotation);
  //     });

  //     setAnnotations(groupedAnnotations);
  //   } else {
  //     setAnnotations({});
  //   }
  //   // }
  // };
  const fetchDataPositions = async (fileId) => {
    try {
      const postData = {
        template_id: fileId,
      };

      const apiData = await post(
        "template/getallPositionsFromTemplateId",
        postData
      );
      console.log("Position Data");
      console.log(apiData);
      if (!apiData.error && apiData.result?.[0]?.position_array) {
        let positionsData = apiData.result[0].position_array;
        console.log("pos");

        // Parse if string
        if (typeof positionsData === "string") {
          positionsData = JSON.parse(positionsData);
        }

        // Group by page number
        const groupedAnnotations = positionsData.reduce((acc, annotation) => {
          const pageNum = annotation.page_no || 1;
          if (!acc[pageNum]) {
            acc[pageNum] = [];
          }

          // Ensure all required properties are present
          const formattedAnnotation = {
            id: annotation.id,
            type: annotation.type,
            x: annotation.x,
            y: annotation.y,
            width: annotation.width || 150,
            height: annotation.height || 30,
            text: annotation.text || "",
            checked: annotation.checked || false,
            imageUrl: annotation.imageUrl || null,
            format: annotation.format || [],
            fontSize: annotation.fontSize || 16,
            fontFamily: annotation.fontFamily || "Helvetica",
            backgroundColor: annotation.backgroundColor || null,
            borderColor: annotation.borderColor || null,
            signerId: annotation.signerId || null,
            signerColor: annotation.signerColor || null,
            isRequired: annotation.isRequired || false,
            page_no: pageNum,
          };

          acc[pageNum].push(formattedAnnotation);
          return acc;
        }, {});

        setAnnotations(groupedAnnotations);
      }

      return {};
    } catch (error) {
      console.error("Error fetching positions:", error);
      return {};
    }
  };
  const [sendEsignModalOpenTemp, setSendEsignModalOpenTemp] = useState(false);

  // Modify your useEffect to include the loader
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hashedParams = params.get("data");
    const stateOpen = params.get("stateOpen");
    console.log("StateOpen", stateOpen);
    if (hashedParams) {
      const unhashedData = unhashIds(hashedParams);
      if (unhashedData) {
        const { documentId, userId } = unhashedData;
        setDocumentId(documentId);
        setUserId(userId);
        if (stateOpen === true || stateOpen === "true") {
          // alert("stateOpen");
          setSendEsignModalOpenTemp(true);
        }
        // Create an async function to handle all API calls
        const fetchAllData = async () => {
          try {
            setIsLoading(true); // Show loader
            await fetchFileData(documentId, userId);
            const userData = await fetchuser(userId); // <-- get user data here
            // await fetchData(documentId);
            await fetchDataPositions(documentId);
            // await fetchSignerData(documentId);
            if (userData?.userTempDocuments === 1) {
              setShowTour("pending"); // or set a flag like setTourPending(true)
            }
          } catch (error) {
            console.error("Error fetching data:", error);
            toastAlert("error", "Error loading document data");
          } finally {
            //  / Hide loader
          }
        };

        fetchAllData();
      }
    }
  }, []);
  useEffect(() => {
    if (!isLoading && pdfImages.length > 0) {
      setIsReadyForTour(true);
    }
  }, [isLoading, pdfImages]);
  useEffect(() => {
    if (showTour === "pending" && isReadyForTour) {
      setShowTour(true); // This will actually show the tour
    }
  }, [isReadyForTour, isLoading]);
  // Usage example - call this when component mounts or when URL is available
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const hashedParams = params.get("data");

  //   if (hashedParams) {
  //     const unhashedData = unhashIds(hashedParams);
  //     if (unhashedData) {
  //       const { documentId, userId } = unhashedData;
  //       setDocumentId(documentId);
  //       setUserId(userId);

  //       // Create an async function to handle all API calls
  //       const fetchAllData = async () => {
  //         try {
  //           await fetchFileData(documentId, userId);
  //           await fetchuser(userId);
  //           await fetchData(documentId);
  //           await fetchDataPositions(documentId);
  //           await fetchSignerData(documentId);
  //         } catch (error) {
  //           console.error("Error fetching data:", error);
  //           toastAlert("error", "Error loading document data");
  //         }
  //       };

  //       fetchAllData();
  //     }
  //   }
  // }, []); // Add dependencies as needed
  const [originalPdf, setOriginalPdf] = useState("");
  const fetchData = async (fileId) => {
    // get Images from db
    const postData = {
      file_id: fileId,
    };
    const apiData = await post("file/getbgImagesByFileId", postData); // Specify the endpoint you want to call
    console.log("apixxsData");

    console.log(apiData);
    if (apiData.error) {
      // setIsLoadingDoc(false);
    } else {
      const pdfUrl = apiData?.result[0]?.image;
      setOriginalPdf(pdfUrl);
      // const pdfUrl = `https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/${documentId}/document.pdf`;
      loadPdfFromUrl(pdfUrl);
      // setImageUrls(apiData.result[0].image);
      // setIsLoadingDoc(false);
      // setIsLoaded(false);
    }
  };
  const handleFileUpload = (fileOrUrl) => {
    if (typeof fileOrUrl === "string") {
      // If it's a URL
      loadPdfFromUrl(fileOrUrl);
    } else {
      // If it's a File object
      setPdfFile(fileOrUrl);
      convertPdfToImages(fileOrUrl);
    }
  };
  const [activeAnnotation, setActiveAnnotation] = useState(null);

  // const getInitialImageDimensions = (event, pageElement, pageNum) => {
  //   const pdfContentBox =
  //     pdfContainerRef.current?.querySelector(".pdf-content-box");
  //   if (!pdfContentBox) return;

  //   // ✅ Get scrolling offsets
  //   const scrollOffsetY = pdfContentBox.scrollTop;
  //   const scrollOffsetX = pdfContentBox.scrollLeft;

  //   // ✅ Get bounding rects
  //   const pageRect = pageElement.getBoundingClientRect();
  //   const pdfContentBoxRect = pdfContentBox.getBoundingClientRect();

  //   // ✅ Calculate the total height of all pages above the clicked page
  //   let totalOffsetAbove = 0;
  //   const allPages = [...document.querySelectorAll(".pdf-page-container")];

  //   for (const page of allPages) {
  //     if (page === pageElement) break;
  //     totalOffsetAbove +=
  //       page.offsetHeight +
  //       parseFloat(window.getComputedStyle(page).marginBottom);
  //   }

  //   // ✅ Compute Y relative to the full document
  //   let yAbsolute = event.clientY + scrollOffsetY - pdfContentBoxRect.top;
  //   let xAbsolute = event.clientX + scrollOffsetX - pageRect.left;

  //   // ✅ Distances from Top, Center, and Bottom
  //   const distanceFromTop = event.clientY - pageRect.top;
  //   const distanceFromBottom = pageRect.bottom - event.clientY;
  //   const pageHeight = pageRect.height;

  //   // Define more granular page regions
  //   const isVeryTopEdge = distanceFromTop < pageHeight * 0.05; // Top 5%
  //   const isNearTop =
  //     distanceFromTop >= pageHeight * 0.05 &&
  //     distanceFromTop < pageHeight * 0.15; // 5-15%
  //   const isUpperCenter =
  //     distanceFromTop >= pageHeight * 0.15 &&
  //     distanceFromTop < pageHeight * 0.4; // 15-40%
  //   const isMiddle =
  //     distanceFromTop >= pageHeight * 0.4 &&
  //     distanceFromTop <= pageHeight * 0.6; // 40-60%
  //   const isLowerCenter =
  //     distanceFromTop > pageHeight * 0.6 &&
  //     distanceFromTop <= pageHeight * 0.85; // 60-85%
  //   const isNearBottom =
  //     distanceFromTop > pageHeight * 0.85 &&
  //     distanceFromTop <= pageHeight * 0.95; // 85-95%
  //   const isVeryBottomEdge = distanceFromTop > pageHeight * 0.95; // Bottom 5%

  //   console.log("distanceFromTop:", distanceFromTop);
  //   console.log("distanceFromBottom:", distanceFromBottom);
  //   console.log(
  //     "isVeryTopEdge:",
  //     isVeryTopEdge,
  //     "isNearTop:",
  //     isNearTop,
  //     "isUpperCenter:",
  //     isUpperCenter,
  //     "isMiddle:",
  //     isMiddle,
  //     "isLowerCenter:",
  //     isLowerCenter,
  //     "isNearBottom:",
  //     isNearBottom,
  //     "isVeryBottomEdge:",
  //     isVeryBottomEdge
  //   );

  //   // Check if current annotation type is text-related
  //   const isTextType = [
  //     "my_text",
  //     "signer_text",
  //     "date",
  //     "signer_date",
  //   ].includes(annotationType);

  //   if (isTextType) {
  //     // Text fields need specific adjustments
  //     if (isVeryTopEdge) {
  //       yAbsolute -= 4; // Strong upward correction at the very top edge
  //     } else if (isNearTop) {
  //       yAbsolute -= 3; // 🔥 Slight upward correction at the top
  //     } else if (isUpperCenter) {
  //       yAbsolute += 3; // 🔥 Tiny correction in upper center
  //     } else if (isMiddle) {
  //       yAbsolute += 6; // ✅ No change in the middle (already working fine)
  //     } else if (isLowerCenter) {
  //       yAbsolute += 13; // 🔥 More correction for lower center
  //     } else if (isNearBottom) {
  //       yAbsolute += 15; // 🔥 More correction at the bottom
  //     } else if (isVeryBottomEdge) {
  //       yAbsolute += 18; // Extra strong correction at very bottom edge
  //     }
  //   } else {
  //     // Non-text fields (signatures, checkmarks, etc.) need different adjustments
  //     if (isVeryTopEdge) {
  //       yAbsolute -= 3; // Less extreme adjustment for non-text at top edge
  //     } else if (isNearTop) {
  //       yAbsolute -= 1; // 🔥 Very slight upward correction at the top
  //     } else if (isUpperCenter) {
  //       yAbsolute += 6; // 🔥 Tiny correction in upper center
  //     } else if (isMiddle) {
  //       yAbsolute += 9; // ✅ Slight lift in the middle for non-text types
  //     } else if (isLowerCenter) {
  //       yAbsolute += 14; // 🔥 More correction for lower center
  //     } else if (isNearBottom) {
  //       yAbsolute += 18; // 🔥 More correction at the bottom
  //     } else if (isVeryBottomEdge) {
  //       yAbsolute += 18; // Extra strong correction at very bottom edge
  //     }
  //   }

  //   // ✅ Convert to percentage relative to the page
  //   const xPercent = (xAbsolute / pageRect.width) * 100;
  //   const yPercent = ((yAbsolute - totalOffsetAbove) / pageRect.height) * 100;

  //   return { xPercent, yPercent };
  // };
  const getInitialImageDimensions = (event, pageElement, pageNum) => {
    const imageElem = pageElement.querySelector(".pdf-image");
    if (!imageElem) return { xPercent: 0, yPercent: 0 };

    // Get the actual rendered PDF dimensions (not container dimensions)
    const imageRect = imageElem.getBoundingClientRect();

    // Calculate click position relative to the PDF image itself
    const relativeX = event.clientX - imageRect.left;
    const relativeY = event.clientY - imageRect.top;

    // Convert to percentage of the actual PDF dimensions
    const xPercent = (relativeX / imageRect.width) * 100;
    const yPercent = (relativeY / imageRect.height) * 100;

    // Ensure coordinates are within bounds
    return {
      xPercent: Math.max(0, Math.min(100, xPercent)),
      yPercent: Math.max(0, Math.min(100, yPercent)),
    };
  };
  // Add this helper function to get initial dimensions based on type
  const getDefaultDimensions = (type, scale) => {
    const settings = annotationSettings[type] || {};

    // Use existing settings if available, otherwise use defaults
    switch (type) {
      case "my_text":
      case "signer_text":
        return {
          // width: (settings.width || 150) / scale,
          // height: (settings.height || 30) / scale,
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_initials":
        return {
          width: settings.width || 250,
          height: settings.height || 100,
        };
      case "signer_initials_text":
        return {
          width: settings.width || 100,
          height: settings.height || 100,
        };
      case "signer_date":
      case "date":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_checkmark":
      case "checkmark":
        return {
          width: settings.width || 30,
          height: settings.height || 30,
        };
      case "signer_dropdown":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      case "signer_chooseImgStamp":
        return {
          width: settings.width || 150,
          height: settings.height || 150,
        };
      case "signer_chooseImgDrivingL":
        return {
          width: settings.width || 350,
          height: settings.height || 200,
        };
      case "signer_chooseImgPassportPhoto":
        return {
          width: settings.width || 450,
          height: settings.height || 300,
        };
      case "highlight":
        return {
          width: settings.width || 150,
          height: settings.height || 30,
        };
      default:
        return {
          width: 150,
          height: 30,
        };
    }
  };
  const truncateName = (name, maxLength = 5) => {
    return name.length > maxLength
      ? `${name.substring(0, maxLength)}...`
      : name;
  };

  // Add this effect to measure first page height
  useEffect(() => {
    if (pdfImages.length > 0) {
      const img = new Image();
      img.onload = () => {
        setFirstPageHeight(img.height);
      };
      img.src = pdfImages[0];
    }
  }, [pdfImages]);
  // Add this useEffect to automatically select the last added signer
  useEffect(() => {
    if (signers.length > 0) {
      setSelectedSignerId(signers[signers.length - 1]);
      setSelectedSigner(signers[signers.length - 1]);
      setActive("2");
    }
  }, [signers]);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);

  const [isInteracting, setIsInteracting] = useState(false);
  const handleSignatureComplete = async (signatureData, typeData) => {
    // Guard clause to prevent execution if no click position
    // Convert base64 to file
    setIsSignatureLoading(true); // Start loading
    try {
      const base64Response = await fetch(signatureData);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "signature.png", {
        type: "image/png",
      });

      // Upload to API
      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading Files");
        return;
      }

      const ImageUrl = apiData.public_url;

      if (editingAnnotation) {
        // Handle editing existing signature
        const img = new Image();
        img.src = signatureData;

        img.onload = () => {
          setAnnotations((prev) => {
            const updatedAnnotations = { ...prev };
            const { pageNum, index } = editingAnnotation;

            updatedAnnotations[pageNum][index] = {
              ...updatedAnnotations[pageNum][index],
              imageUrl: ImageUrl,
            };

            return updatedAnnotations;
          });

          setEditingAnnotation(null);
          setSignatureModalOpen(false);
          setIsSignatureLoading(false); // Stop loading
        };
      } else {
        if (!lastClickPosition) {
          console.log("No click position available");
          // setIsSignatureLoading(false); // Stop loading
          return;
        }

        const img = new Image();
        img.src = signatureData;

        img.onload = () => {
          const intrinsicWidth = img.width;
          const intrinsicHeight = img.height;
          const widthd = typeData ? 100 : 100;
          const widthdt = typeData ? 400 : 200;

          // Define the desired display width
          const displayWidth = initialsBox ? widthd : widthdt;
          const aspectRatio = intrinsicWidth / intrinsicHeight;
          const displayHeight = displayWidth / aspectRatio;

          // Adjust dimensions based on the current scale
          const adjustedWidth = displayWidth / scale;
          const adjustedHeight = displayHeight / scale;

          setAnnotations((prev) => {
            const pageAnnotations = prev[activePage] || [];
            const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

            if (loadingIndex !== -1) {
              const newAnnotations = [...pageAnnotations];
              newAnnotations[loadingIndex] = {
                ...newAnnotations[loadingIndex],
                imageUrl: ImageUrl,
                // width: adjustedWidth,
                // height: adjustedHeight,
                isLoading: false,
                isSignature: true,
              };
              handleAnnotationClick(activePage, loadingIndex, newAnnotations);

              return {
                ...prev,
                [activePage]: newAnnotations,
              };
            }

            return prev;
          });

          // Clear the last click position after using it
          setLastClickPosition(null);
          setSignatureModalOpen(false);
          setIsSignatureLoading(false); // Stop loading
        };
      }
    } catch (error) {
      console.error("Error uploading signature:", error);
      setIsSignatureLoading(false); // Stop loa
      toastAlert("error", "Error uploading signature");
      setAnnotations((prev) => {
        const pageAnnotations = prev[activePage] || [];
        return {
          ...prev,
          [activePage]: pageAnnotations.filter((a) => !a.isLoading),
        };
      });
    }
  };
  const getResizeHandles = (type) => {
    if (type === "signer_text") {
      return {
        topRight: false,
        topLeft: false,
        bottomLeft: false,
        top: false,
        right: false,
        bottom: false,
        left: false,
        bottomRight: true, // Only bottom-right for signer_text
      };
    }

    if (type === "highlight") {
      return {
        topRight: true,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true,
      }; // Full freeform for highlight
    }

    if (shouldLockAspectRatio(type)) {
      return {
        topRight: false,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true,
      }; // Aspect ratio locked types
    }

    // Default case (other types - restricted)
    return {
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false,
    };
  };

  const shouldLockAspectRatio = (type) => {
    const typesWithLockedAspectRatio = [
      "stamp",
      // "highlight",
      "my_signature",
      "my_initials",
      "signer_initials",
      "signer_initials_text",
      "signer_chooseImgStamp",
      "signer_chooseImgDrivingL",
      "signer_chooseImgPassportPhoto",
    ];
    return typesWithLockedAspectRatio.includes(type);
  };
  // 1. Add a new state for tracking the annotation being edited
  const [editingAnnotation, setEditingAnnotation] = useState(null);

  // 2. Add handler for editing signature
  const handleEditSignature = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    setInitialBox(annot.type === "my_initials");
    setSignatureModalOpen(true);
  };

  // 3. Add handler for editing stamp
  const handleEditStamp = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    stampInputRef.current.click();
  };
  const [lastClickPosition, setLastClickPosition] = useState(null);
  const [loadingPositions, setLoadingPositions] = useState({});
  // Check if the current annotationType is in the array
  const calculateTextWidth = (
    text,
    fontSize = 16,
    fontFamily = "Helvetica"
  ) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    ctx.font = `${fontSize}px ${fontFamily}`;

    const textWidth = Math.ceil(ctx.measureText(text).width);

    const padding = 10; // Minimum, adjust if you want some breathing room
    return textWidth + padding; // Remove excessive padding
  };

  const handlePdfClick = (event) => {
    if (!isAnnotating || isDragging || isResizing || isInteracting) return;

    const pageElement = event.target.closest(".pdf-page-container");
    if (!pageElement) return;
    // Get page number from element ID
    const pageNum = parseInt(pageElement.id.split("-")[1]);

    const isAnnotationClick =
      event.target.closest(".annotation") ||
      event.target.closest(".react-rnd-resizable-handle") ||
      event.target.closest(".MuiIconButton-root");

    if (isAnnotationClick) return;

    // // Get saved settings for the current annotation type
    const settings = annotationSettings[annotationType] || {};

    // scroll

    // end
    const { xPercent, yPercent } = getInitialImageDimensions(
      event,
      pageElement
    );
    const pageWidth = pageElement.getBoundingClientRect().width;
    const pageHeight = pageElement.getBoundingClientRect().height;

    console.log("pdf width", pageWidth);

    const fontSize = settings.fontSize || 20;
    // const fontSizePt = settings.fontSize || 12; // Default in pt
    // const fontSizePx = fontSizePt * (96 / 72); // To render in browser
    // console.log("fontsize", fontSizePt);
    // console.log("fontsizePCX", fontSizePx);

    // Apply this `fontSizePx` in the RND/TextField

    const defaultWidth = 150; // Default text box width in pixels
    const defaultHeight = 30; // Default height in pixels
    const pageRect = pageElement.getBoundingClientRect();
    let baseAnnotation = {
      id: Date.now(),
      x: xPercent,
      y: yPercent,
      page_no: pageNum,
      type: annotationType,
      width: settings.width / scale,
      height: settings.height / scale,
    };
    if (annotationType === "my_text") {
      const calculatedWidth = calculateTextWidth(
        "Text ....",
        settings.fontSize || 20,
        settings.fontFamily || "Helvetica"
      );
      // Keep created text field height consistent with configured/default size.
      // A too-small box causes the input to overflow upward and look misaligned.
      const textFieldHeightPx = settings.height || Math.max(fontSize * 1.4, 30);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "my_text",

        // x: xPercent,
        // y: yPercent,
        width: (calculatedWidth / pageRect.width) * 100,
        height: (textFieldHeightPx / pageRect.height) * 100,
        text: "",
        fontSize, // Save font size directly
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        backgroundColor: "rgba(0, 247, 255, 0.25)",
        borderColor: "rgba(0, 0, 0, 0.23)",
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        setTimeout(() => {
          const annotationIndex = updatedAnnotations[activePage].length - 1;
          const element =
            annotationRefs.current[`${activePage}-${annotationIndex}`];
          if (element) {
            element.focus();
            if (cursorRef.current) {
              cursorRef.current.style.top = `${event.clientY + 50}px`;
              cursorRef.current.style.left = `${event.clientX}px`;
              cursorRef.current.style.display = "none";
              setTimeout(() => {
                if (cursorRef.current) {
                  cursorRef.current.style.display = "block";
                }
              }, 100);
            }
          }
        }, 0);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_text") {
      const calculatedHeight = settings.fontSize * 1.7;
      console.log("calculatedHeight", calculatedHeight);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        text: "",
        imageUrl: null,
        type: annotationType,
        fontSize,
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        // fontSize: 14,
        // fontFamily: "Helvetica",
        // format: [],
        // width: 150 / scale,

        // height: 30 / scale,
        // width: (textFieldMetrics.width || 120) / scale,
        // height: (textFieldMetrics.height || 30) / scale,
        width: (settings.width / pageRect.width) * 100,

        height: (calculatedHeight / pageRect.height) * 100,
        backgroundColor: `${selectedSigner?.color}`,
        signerColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        signerId: selectedSigner?.signer_id, // Add signer ID
        signerName: selectedSigner?.name, // Optional: add signer name for reference
        // isRequired: false,
        isRequired: globalIsRequired,
      };
      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_dropdown") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: 150 / scale,
        // height: 30 / scale,
        width: (150 / pageRect.width) * 100,
        height: (30 / pageRect.height) * 100,
        page_no: pageNum, //
        options: [],
        selectedOption: "",
        signerId: selectedSigner?.signer_id,
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_date" || annotationType === "date") {
      const currentDate = new Date();
      console.log("sin er date", annotationType);
      const defaultFormat = "MMM dd, yyyy";
      try {
        const formattedDate = format(
          new Date(),
          settings.dateFormat || "MMM dd, yyyy"
        );
        // const newAnnotation = {
        //   id: Date.now(),
        //   x,
        //   y,
        //   text: formattedDate,
        //   type: "date",
        //   fontSize: 14,
        //   fontFamily: "Helvetica",
        //   format: [],
        //   dateFormat: defaultFormat,
        //   width: 150 / scale,
        //   height: 30 / scale,
        //   date: currentDate,
        // };
        const calculatedWidth = calculateTextWidth(
          `${formattedDate}T`,
          settings.fontSize || 21
        );
        const newAnnotation = {
          ...baseAnnotation,
          id: Date.now(),
          // x: xPercent,
          // y: yPercent,
          // text: formattedDate,
          text: format(new Date(), settings.dateFormat || "MMM dd, yyyy"),
          type: annotationType,
          // fontSize: 14,21
          fontSize: settings.fontSize || 20,
          fontFamily: "Helvetica",
          format: [],
          // dateFormat: defaultFormat,
          dateFormat: settings.dateFormat || defaultFormat,
          // width: calculatedWidth,
          // height: 30,
          width: (calculatedWidth / pageRect.width) * 100,
          height: (30 / pageRect.height) * 100,
          signerId:
            annotationType === "signer_date" ? selectedSigner?.signer_id : null,
          page_no: pageNum, //
          date: currentDate,
          backgroundColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          signerColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          borderColor:
            annotationType === "signer_date"
              ? selectedSigner?.color
              : "rgba(0, 0, 0, 0.23)",
          isRequired:
            annotationType === "signer_date" ? globalIsRequired : false,
        };
        console.log("newAnnotation", newAnnotation);
        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          // Get the index of the newly added annotation
          const newIndex = updatedAnnotations[activePage].length - 1;

          // Set the selected annotation immediately after creation
          setSelectedAnnotation({
            ...newAnnotation,
            pageNum: activePage,
            index: newIndex,
          });

          // Set the active annotation ID
          setActiveAnnotationId(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      } catch (error) {
        console.error("Error creating date annotation:", error);
      }
      return;
    }
    // Add this condition for stamp type
    if (annotationType === "stamp") {
      const clickPosition = {
        x: xPercent,
        y: yPercent,
        width: (150 / pageRect.width) * 100,
        height: (150 / pageRect.height) * 100,
      };
      setPageNoClicked(pageNum);
      setStampClickPosition(clickPosition); // Store click position
      const input = stampInputRef.current;
      input.click();
      return;
    }
    // In App.js
    if (annotationType === "checkmark") {
      // const newAnnotation = {
      //   ...baseAnnotation,
      //   id: Date.now(),
      //   // x,
      //   // y,
      //   type: "checkmark",
      //   checked: true,
      //   page_no: pageNum, //
      //   width: (250 / pageRect.width) * 100,
      //   height: (250 / pageRect.height) * 100,
      // };
      const defaultSize = 34; // or whatever fits your design
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "checkmark",
        checked: true, // default unchecked
        width: (defaultSize / pageWidth) * 100,
        height: (defaultSize / pageHeight) * 100,
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    if (annotationType === "signer_checkmark") {
      const defaultSize = 34; // or whatever fits your design

      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "signer_checkmark",

        backgroundColor: `${selectedSigner?.color}`, // Add 20 for opacity
        signerColor: `${selectedSigner?.color}`, // Add 20 for opacity

        borderColor: selectedSigner?.color,
        page_no: pageNum, //
        checked: false,
        signerId: selectedSigner?.signer_id,

        width: (defaultSize / pageWidth) * 100,
        height: (defaultSize / pageHeight) * 100,
        isRequired: globalIsRequired,
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    // In App.js, add to handlePdfClick function
    if (annotationType === "highlight") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "highlight",
        width: (120 / pageRect.width) * 100,
        height: (25 / pageRect.height) * 100,
        // width: 120 / scale,
        page_no: pageNum, //
        // height: 25 / scale,
        backgroundColor: "rgba(255, 255, 0, 0.3)", // Light yellow with opacity
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        // setAnnotations((prev) => {
        //   const updatedAnnotations = {
        //     ...prev,
        //     [activePage]: [...(prev[activePage] || []), newAnnotation],
        //   };
        //   const newIndex = updatedAnnotations[activePage].length - 1;
        //   setActiveAnnotationId(`${activePage}-${newIndex}`);

        //   // Set the selected annotation immediately after creation
        //   setSelectedAnnotation({
        //     ...newAnnotation,
        //     pageNum: activePage,
        //     index: newIndex,
        //   });

        return updatedAnnotations;
      });
      return;
    }

    if (annotationType === "my_signature") {
      const loadingId = `${pageNum}-${Date.now()}`;

      // Create temporary loading annotation
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: annotationType === "my_signature" ? 250 : 100,
        // height: annotationType === "my_signature" ? 100 : 80,
        width: (250 / pageRect.width) * 100,
        height: (100 / pageRect.height) * 100,
        isLoading: true,
        page_no: pageNum,
      };

      // Add the temporary annotation
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: yPercent });
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      // Store the loading position info
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (annotationType === "my_initials") {
      const loadingId = `${pageNum}-${Date.now()}`;

      // Create temporary loading annotation
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: annotationType === "my_signature" ? 250 : 100,
        // height: annotationType === "my_signature" ? 100 : 80,
        width: (100 / pageRect.width) * 100,
        height: (100 / pageRect.height) * 100,
        isLoading: true,
        page_no: pageNum,
      };

      // Add the temporary annotation
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: yPercent });
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      // Store the loading position info
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (
      [
        "signer_initials",
        "signer_initials_text",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
      ].includes(annotationType)
    ) {
      const dimensions = getDefaultDimensions(annotationType, scale);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: dimensions.width,
        // height: dimensions.height,
        width: (dimensions.width / pageRect.width) * 100,
        height: (dimensions.height / pageRect.height) * 100,
        signerId: selectedSigner?.signer_id,
        page_no: pageNum, //
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        imageUrl: null, // Will be filled when user adds content
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: settings.isRequired || false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
  };
  // Inside App.js, modify the handlePdfClick function

  const handleAnnotationClick = (pageNum, index, annotation) => {
    // console.log("clicked texct ");
    // console.log("clicked texct ", annotation);
    if (EditingTemp === false) {
      return;
    }
    const annotationId = `${pageNum}-${index}`;
    setActiveAnnotationId(annotationId);
    setActiveAnnotation(annotationId);
    setSelectedAnnotation({
      ...annotation,
      pageNum,
      index,
    });
    // Set focused annotation
    setFocusedAnnotation(annotationId);
  };

  // Add this new state at the top of your EsignSetupTemplate component

  // Modify handleAnnotationTextChange
  const handleAnnotationTextChange1 = (e, pageNum, index) => {
    if (selectedAnnotation.type === "my_text") {
      const newText = e.target.value;
      const inputEl = annotationRefs.current[`${pageNum}-${index}`];
      if (!inputEl) return;

      const annotationId = `${pageNum}-${index}`;
      const currentAnnotation = annotations[pageNum][index];
      const currentWidth = currentAnnotation.width * scale;

      // Create temporary span for text measurement
      const span = document.createElement("span");
      const computedStyle = window.getComputedStyle(inputEl);
      span.style.cssText = `
        visibility: hidden;
        position: fixed;
        font-family: ${computedStyle.fontFamily};
        font-size: ${computedStyle.fontSize};
        font-weight: ${computedStyle.fontWeight};
        font-style: ${computedStyle.fontStyle};
        letter-spacing: ${computedStyle.letterSpacing};
        white-space: pre;
        padding: ${computedStyle.padding};
    `;
      span.innerText = newText || " ";
      document.body.appendChild(span);

      const textWidth = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      // Calculate width for **one character** (like "M" which is usually widest)
      span.innerText = "W"; // This gives us a realistic "minimum" single character width
      document.body.appendChild(span);
      const singleCharWidth = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      const padding = 16;
      const buffer = 2;

      // This replaces the hardcoded 150px minimum width:
      const dynamicMinWidth = Math.max(singleCharWidth + padding + buffer, 50);

      // Calculate required width for text
      const requiredWidth = Math.ceil((textWidth + padding + buffer) / 10) * 10;

      // Check if this field has been filled before
      const hasBeenFilled = textFieldHistory[annotationId]?.hasBeenFilled;
      const maxReachedWidth =
        textFieldHistory[annotationId]?.maxWidth || dynamicMinWidth;

      // Determine if field is being filled now
      const isFillingNow = requiredWidth > maxReachedWidth;

      // Update field history
      setTextFieldHistory((prev) => ({
        ...prev,
        [annotationId]: {
          hasBeenFilled: hasBeenFilled || isFillingNow,
          maxWidth: Math.max(maxReachedWidth, requiredWidth),
        },
      }));

      // Calculate new width based on state
      let newWidth;
      if (!hasBeenFilled) {
        newWidth = Math.max(dynamicMinWidth, requiredWidth);
      } else {
        // Allow shrinking down to `dynamicMinWidth` (single character width + padding)
        newWidth = Math.max(dynamicMinWidth, requiredWidth);
      }

      const scaledWidth = newWidth / scale;

      if (newWidth !== annotationSettings.my_text.width) {
        setTextFieldMetrics((prev) => ({
          ...prev,
          width: newWidth,
        }));

        setAnnotationSettings((prev) => ({
          ...prev,
          my_text: {
            ...prev.my_text,
            width: newWidth,
          },
        }));
      }

      // Update annotation
      setAnnotations((prev) => {
        const pageAnns = [...(prev[pageNum] || [])];
        pageAnns[index] = {
          ...pageAnns[index],
          text: newText,
          width: scaledWidth,
        };
        return { ...prev, [pageNum]: pageAnns };
      });
    }
  };
  const handleAnnotationTextChange = (e, pageNum, index) => {
    if (EditingTemp === false) {
      return;
    }
    if (selectedAnnotation?.type === "my_text") {
      const newText = e.target.value;
      const inputEl = annotationRefs.current[`${pageNum}-${index}`];
      if (!inputEl) return;

      const currentAnnotation = annotations[pageNum][index];
      const fontSizePx = currentAnnotation.fontSize || 16;

      // ✅ Text measurement (core logic)
      const span = document.createElement("span");
      const computedStyle = window.getComputedStyle(inputEl);
      span.style.cssText = `
        visibility: hidden;
        position: fixed;
        font-family: ${computedStyle.fontFamily};
        font-size: ${fontSizePx}px;
        font-weight: ${computedStyle.fontWeight};
        font-style: ${computedStyle.fontStyle};
        letter-spacing: ${computedStyle.letterSpacing};
        white-space: pre;
        padding: 0;
    `;
      span.innerText = newText || " ";
      document.body.appendChild(span);

      const textWidthPx = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      // ✅ Page size (to convert px → %)
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;
      const pageWidthPx = pageElement.offsetWidth;

      // ✅ Define a buffer (you can tweak this based on design needs)
      const bufferPx = 20; // extra breathing space on right side (like Docusign)

      // ✅ Total box width in px (text width + buffer)
      const boxWidthPx = textWidthPx + bufferPx;

      // ✅ Minimum width (in case user deletes all text, box should not collapse too small)
      const minWidthPx = 60;

      // ✅ Final width to store (in px)
      const finalWidthPx = Math.max(boxWidthPx, minWidthPx);

      // ✅ Convert to % for storing in annotation (since your positions are % based)
      const newWidthPercent = (finalWidthPx / pageWidthPx) * 100;
      // ✅ Prevent Text from Moving Up (Height Restriction)

      // ✅ Update annotation (main state update)
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        pageAnnotations[index] = {
          ...pageAnnotations[index],
          text: newText,
          width: newWidthPercent, // save in %
        };
        return { ...prev, [pageNum]: pageAnnotations };
      });

      // ✅ Update live metrics for UI (this stays in px)
      setTextFieldMetrics((prev) => ({
        ...prev,
        width: finalWidthPx,
      }));

      // ✅ Optional: If you want to preset this for future fields (like default size for new my_text)
      setAnnotationSettings((prev) => ({
        ...prev,
        my_text: {
          ...prev.my_text,
          width: finalWidthPx, // next new field gets this default width
        },
      }));
    }
  };

  const [isDeleting, setIsDeleting] = useState(false);
  // Handler to delete an annotation
  const handleDeleteAnnotation = (pageNum, index) => {
    setIsDeleting(true);
    const annotationElement = document.querySelector(
      `[data-annot-id="${pageNum}-${annotations[pageNum][index].id}"]`
    );
    if (annotationElement) {
      annotationElement.style.transition = "none";
    }

    setAnnotations((prev) => ({
      ...prev,
      [pageNum]: Array.isArray(prev[pageNum]) ? prev[pageNum].filter((_, i) => i !== index) : [],
    }));
    // setAnnotations((prev) => ({
    //   ...prev,
    //   [pageNum]: prev[pageNum].filter((_, i) => i !== index),
    // }));
  };

  // Memoize render image function
  const renderImage = useCallback((image, index, isMainView = true) => {
    return (
      <img
        src={image}
        alt={`Page ${index + 1}`}
        className={isMainView ? "pdf-image" : "thumbnail-image"}
        loading="lazy"
      />
    );
  }, []);
  //  //correct

  // correct
  const handleUpdateAnnotation = (updatedProps) => {
    if (!selectedAnnotation) return;

    const { pageNum, index } = selectedAnnotation;
    const currentAnnotation = annotations[pageNum][index];

    const type = currentAnnotation.type;

    // Merge current annotation with updated properties
    let mergedAnnotation = {
      ...currentAnnotation,
      ...updatedProps,
    };
    console.log("current ", mergedAnnotation);
    console.log("current1 ", currentAnnotation);
    console.log("updatedProps ", updatedProps);

    if (
      type === "my_text" ||
      type === "signer_text" ||
      type === "date" ||
      type === "signer_date"
    ) {
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;

      const pageWidth = pageElement.offsetWidth;
      const pageHeight = pageElement.offsetHeight;

      // 1️⃣ Create offscreen span for accurate measurement
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "pre";

      // const newFontSize =
      //   updatedProps.fontSize || currentAnnotation.fontSize || 16;
      // const newFontFamily =
      //   updatedProps.fontFamily || currentAnnotation.fontFamily || "Helvetica";
      // const newFontWeight = updatedProps.format?.includes("bold")
      //   ? "bold"
      //   : "normal";
      // const newFontStyle = updatedProps.format?.includes("italic")
      //   ? "italic"
      //   : "normal";
      // const letterSpacing =
      //   updatedProps.letterSpacing ||
      //   currentAnnotation.letterSpacing ||
      //   "normal";
      const newFontSize =
        mergedAnnotation.fontSize || currentAnnotation.fontSize || 16;
      const newFontFamily =
        mergedAnnotation.fontFamily ||
        currentAnnotation.fontFamily ||
        "Helvetica";
      const newFontWeight = mergedAnnotation.format?.includes("bold")
        ? "bold"
        : "normal";
      const newFontStyle = mergedAnnotation.format?.includes("italic")
        ? "italic"
        : "normal";
      const letterSpacing = mergedAnnotation.letterSpacing || "normal";
      tempSpan.style.fontSize = `${newFontSize}px`;
      tempSpan.style.fontFamily = newFontFamily;
      tempSpan.style.fontWeight = newFontWeight;
      tempSpan.style.fontStyle = newFontStyle;
      tempSpan.style.letterSpacing = letterSpacing;

      // 2️⃣ Preserve original baseline before any changes
      const oldHeightPx = (currentAnnotation.height / 100) * pageHeight;
      const baselinePx = currentAnnotation.y * pageHeight + oldHeightPx; // Fixed bottom position

      // 3️⃣ Measure new text size after applying the changes
      const textToMeasure = mergedAnnotation.text || "Text";
      tempSpan.innerText = textToMeasure;

      document.body.appendChild(tempSpan);

      const measuredWidth = tempSpan.getBoundingClientRect().width;
      const measuredHeight = tempSpan.getBoundingClientRect().height;

      document.body.removeChild(tempSpan);

      // 4️⃣ Add consistent padding (same as your MUI TextField)
      const paddingX = 8; // Horizontal padding (left+right)
      const paddingY = 6; // Vertical padding (top+bottom)

      const finalWidthPx = measuredWidth + paddingX * 2;
      const finalHeightPx = measuredHeight + paddingY;

      // 5️⃣ Convert to percentage (for your positioning system)
      const newWidthPercent = (finalWidthPx / pageWidth) * 100;
      const newHeightPercent = (finalHeightPx / pageHeight) * 100;

      let newYPercent = currentAnnotation.y; // Default: Keep Y same

      // 6️⃣ Separate logic for font size changes vs. font family/style changes
      if (updatedProps.fontSize) {
        // ✅ Your logic for font size changes
        const heightDiffPx = finalHeightPx - oldHeightPx;
        const heightDiffPercent = (heightDiffPx / pageHeight) * 100;
        newYPercent = currentAnnotation.y - heightDiffPercent; // Move text upwards when increasing size
      } else if (
        updatedProps.fontFamily ||
        updatedProps.format?.includes("bold") ||
        updatedProps.format?.includes("italic")
      ) {
        // ✅ My logic for font family & style changes (keep baseline fixed)
        newYPercent = (baselinePx - finalHeightPx) / pageHeight;
      }

      // 7️⃣ Special Handling for signer_text minimum width
      if (type === "signer_text") {
        const calculatedWidth = calculateTextWidth(
          "Text ....",
          newFontSize,
          newFontFamily
        );
        console.log("tet width", calculatedWidth);
        const minWidthPx = calculatedWidth; // Minimum width for signer text
        const minWidthPercent = (minWidthPx / pageWidth) * 100;
        if (mergedAnnotation.width < minWidthPercent) {
          mergedAnnotation.width = Math.max(newWidthPercent, minWidthPercent);
        }
        // mergedAnnotation.width = Math.max(newWidthPercent, minWidthPercent);
      } else {
        mergedAnnotation.width = newWidthPercent;
      }

      mergedAnnotation.height = newHeightPercent;
      mergedAnnotation.y = newYPercent; // ✅ Ensures text grows upwards while baseline stays fixed
    }

    // ✅ Update annotations state
    setAnnotations((prevAnnotations) => {
      const pageAnnotations = [...(prevAnnotations[pageNum] || [])];
      pageAnnotations[index] = mergedAnnotation;

      return {
        ...prevAnnotations,
        [pageNum]: pageAnnotations,
      };
    });

    // ✅ Sync updated styles to annotationSettings (optional)
    setAnnotationSettings((prevSettings) => ({
      ...prevSettings,
      [selectedAnnotation.type]: {
        ...prevSettings[selectedAnnotation.type],
        ...updatedProps,
      },
    }));

    // ✅ Global `isRequired` handling
    if (updatedProps.isRequired !== undefined) {
      setGlobalIsRequired(updatedProps.isRequired);
    }
  };

  const renderAnnotations = useCallback(
    (pageNum) => {
      const pageAnnotations = annotations[pageNum] || [];

      const imageElem = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!imageElem) return null; // Safe check if page not rendered yet

      const pageWidth = imageElem.offsetWidth;
      const pageHeight = imageElem.offsetHeight;

      return pageAnnotations.map((annot, index) => {
        const pixelX = (annot.x / 100) * pageWidth;
        const pixelY = (annot.y / 100) * pageHeight;
        const pixelWidth = (annot.width / 100) * pageWidth;
        const pixelHeight = (annot.height / 100) * pageHeight;

        return (
          <Rnd
            size={{ width: pixelWidth, height: pixelHeight }}
            position={{ x: pixelX, y: pixelY }}
            // className="react-rnd-resizable-handle"
            // scale={scale}
            key={`${pageNum}-${index}`}
            data-annot-id={`${pageNum}-${annot.id}`}
            default={{
              x: annot.x,
              y: annot.y,
            }}
            bounds="parent"
            dragGrid={[5, 5]}
            // size={{ width: annot.width, height: annot.height }}
            // position={{ x: annot.x, y: annot.y }}
            disableDragging={EditingTemp ? isResizing : true}
            enableResizing={
              !isDragging &&
              activeAnnotation === `${pageNum}-${index}` &&
              getResizeHandles(annot.type)
            }
            onClick={(e) => {
              e.stopPropagation();
              if (shouldLockAspectRatio(annot.type)) {
                setActiveAnnotation(`${pageNum}-${index}`);
              }
            }}
            onMouseDown={(e) => {
              if (shouldLockAspectRatio(annot.type)) {
                setActiveAnnotation(`${pageNum}-${index}`);
              }
            }}
            // disableDragging={isResizing}
            // cancel=".react-rnd-resizable-handle"
            enableUserSelectHack={false}
            style={{
              transition:
                isDragging || isResizing || isDeleting
                  ? "none"
                  : "transform 0.1s ease-out",
              cursor: isDragging
                ? "move !important"
                : isResizing
                  ? "nw-resize !important"
                  : "default !important",
            }}
            onDragStart={(e) => {
              e.stopPropagation();
              if (EditingTemp === false) {
                return;
              }
              setIsDragging(true);
              setIsInteracting(true);
              document.body.style.cursor =
                annot.type === "my_text" ? "grab" : "move";
            }}
            onDragStop={(e, d) => {
              setIsDragging(false);
              if (EditingTemp === false) {
                return;
              }
              setTimeout(() => {
                setIsInteracting(false);
              }, 300);
              const imageElem = document.querySelector(
                `#img-${pageNum} .pdf-image`
              );
              const imageRect = imageElem.getBoundingClientRect();

              // Calculate relative positions while maintaining scale
              // const relativeX = d.x / scale;
              // const relativeY = d.y / scale;
              const relativeX = (d.x / pageWidth) * 100;
              const relativeY = (d.y / pageHeight) * 100;
              setAnnotations((prev) => ({
                ...prev,
                [pageNum]: prev[pageNum].map((a, i) =>
                  i === index ? { ...a, x: relativeX, y: relativeY } : a
                ),
              }));

              // Reset cursor
              document.body.style.cursor =
                annot.type === "my_text" ? "text" : "default";
            }}
            onResizeStart={(e, direction, ref) => {
              e.stopPropagation();
              if (EditingTemp === false) {
                return;
              }
              setIsResizing(true);
              setIsInteracting(true);
              setIsInteracting(true);
              if (cursorRef.current) {
                cursorRef.current.style.display = "none";
              }
              // Hide during resize
              document.body.style.cursor = "default";
            }}
            onResize={(e, direction, ref, delta, position) => {
              if (EditingTemp === false) {
                return;
              }
              if (!isDragging) {
                const imageElem = document.querySelector(
                  `#img-${pageNum} .pdf-image`
                );

                let newWidth = (ref.offsetWidth / pageWidth) * 100;
                let newHeight = (ref.offsetHeight / pageHeight) * 100;
                let newX = (position.x / pageWidth) * 100;
                let newY = (position.y / pageHeight) * 100;
                // For all types except signer_text, we allow free resizing or aspect ratio lock
                if (annot.type === "highlight") {
                  newWidth = Math.max(2, newWidth);
                  newHeight = Math.max(1, newHeight);
                  // newWidth = newWidth;
                  // newHeight = newHeight;
                } else if (annot.type === "signer_initials") {
                  newWidth = Math.max(10, newWidth);
                  newHeight = Math.max(10, newHeight);
                } else if (annot.type === "signer_initials_text") {
                  newWidth = Math.max(5, newWidth);
                  newHeight = Math.max(2, newHeight);
                } else if (annot.type === "signer_chooseImgStamp") {
                  newWidth = Math.max(4, newWidth);
                  newHeight = Math.max(4, newHeight);
                } else if (
                  annot.type === "signer_chooseImgDrivingL" ||
                  annot.type === "signer_chooseImgPassportPhoto"
                ) {
                  newWidth = Math.max(15, newWidth);
                  newHeight = Math.max(12, newHeight);
                }

                // Restrict to bounds
                newWidth = Math.min(newWidth, pageWidth - newX);
                newHeight = Math.min(newHeight, pageHeight - newY);

                if (annot.type === "signer_text") {
                  setTextFieldMetrics((prev) => ({
                    ...prev,
                    width: newWidth * scale,
                  }));
                  // ✅ Special handling for `signer_text` - only allow width resize
                  requestAnimationFrame(() => {
                    setAnnotations((prev) => ({
                      ...prev,
                      [pageNum]: prev[pageNum].map((a, i) =>
                        i === index
                          ? {
                            ...a,
                            width: newWidth,
                            x: newX, // Allow dragging too
                            y: newY, // Allow dragging too
                          }
                          : a
                      ),
                    }));
                  });

                  // Optional: Update annotation settings for signer_text width
                  setAnnotationSettings((prev) => ({
                    ...prev,
                    [annot.type]: {
                      ...prev[annot.type],
                      width: (newWidth / 100) * pageWidth,
                    },
                  }));
                } else if (shouldLockAspectRatio(annot.type)) {
                  // Other image-based types keep aspect ratio
                  const aspectRatio = annot.width / annot.height;
                  newHeight = newWidth / aspectRatio;

                  requestAnimationFrame(() => {
                    setAnnotations((prev) => ({
                      ...prev,
                      [pageNum]: prev[pageNum].map((a, i) =>
                        i === index
                          ? {
                            ...a,
                            width: newWidth,
                            height: newHeight,
                            x: newX,
                            y: newY,
                          }
                          : a
                      ),
                    }));
                  });

                  setAnnotationSettings((prev) => ({
                    ...prev,
                    [annot.type]: {
                      ...prev[annot.type],
                      width: (newWidth / 100) * pageWidth,
                      height: (newHeight / 100) * pageHeight,
                    },
                  }));
                } else {
                  // Other free-form types (highlight etc.)
                  requestAnimationFrame(() => {
                    setAnnotations((prev) => ({
                      ...prev,
                      [pageNum]: prev[pageNum].map((a, i) =>
                        i === index
                          ? {
                            ...a,
                            width: newWidth,
                            height: newHeight,
                            x: newX,
                            y: newY,
                          }
                          : a
                      ),
                    }));
                  });

                  setAnnotationSettings((prev) => ({
                    ...prev,
                    [annot.type]: {
                      ...prev[annot.type],
                      width: newWidth,
                      height: newHeight,
                    },
                  }));
                }
              }
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
              if (EditingTemp === false) {
                return;
              }
              setIsResizing(false);
              setTimeout(() => {
                setIsInteracting(false);
              }, 300);
              document.body.style.cursor = "default";
              // cursorRef.current.style.display = "block"; // Restore custom cursor
              // document.body.style.cursor = "default";
              setActiveAnnotation(`${pageNum}-${index}`);
            }}
            // In your renderAnnotations function, update the resizeHandleStyles
            resizeHandleStyles={
              EditingTemp
                ? {
                  bottomRight: {
                    className: "react-rnd-resizable-handle-se",
                    width: "10px",
                    height: "10px",
                    background: "rgb(0, 145, 255)",
                    borderRadius: "50%",
                    bottom: "-5px",
                    right: "-5px",
                    zIndex: 1000,
                    pointerEvents: "auto",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      width: "20px",
                      height: "20px",
                      cursor: "se-resize !important",
                    },
                  },
                  bottomLeft: {
                    className: "react-rnd-resizable-handle-sw",
                    width: "10px",
                    height: "10px",
                    background: "rgb(0, 145, 255)",
                    borderRadius: "50%",
                    bottom: "-5px",
                    left: "-5px",
                    zIndex: 1000,
                    pointerEvents: "auto",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      width: "20px",
                      height: "20px",
                      cursor: "sw-resize !important",
                    },
                  },
                  topLeft: {
                    className: "react-rnd-resizable-handle-nw",
                    width: "10px",
                    height: "10px",
                    background: "rgb(0, 145, 255)",
                    borderRadius: "50%",
                    top: "-5px",
                    left: "-5px",
                    zIndex: 1000,
                    pointerEvents: "auto",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      width: "20px",
                      height: "20px",
                      cursor: "nw-resize !important",
                    },
                  },
                }
                : {}
            }
          >
            <Box
              className="annotation"
              data-type={annot.type}
              sx={{
                // width: `${calculateImageWidth(scale)}%`,
                // minWidth: `${calculateImageWidth(scale)}%`,
                position: "relative",
                display: "flex",
                cursor:
                  annot.type === "my_text" || annot.type === "date"
                    ? "text"
                    : annot.type === "checkmark" ||
                      annot.type === "signer_checkmark"
                      ? "pointer !important"
                      : "default !important",
                // cursor: isDragging ? "move" : "default",
                alignItems:
                  annot.type === "my_text" || annot.type === "signer_text"
                    ? "flex-start"
                    : "center",
                transition:
                  isDragging || isResizing || isDeleting
                    ? "none"
                    : "width 0.1s ease-out",
                // padding: "2px",
                // backgroundColor:
                //   annot.type === "highlight"
                //     ? "transparent"
                //     : "rgba(0, 247, 255, 0.25)",
                // transformOrigin: "top left",
                // transform: `scale(${scale})`,
                "&:hover": {
                  "& .resize-handle": {
                    opacity: 1,
                  },
                },
              }}
            >
              {annot?.type === "my_text" ? (
                <TextField
                  variant="outlined"
                  value={annot?.text}
                  onChange={(e) =>
                    handleAnnotationTextChange(e, pageNum, index)
                  }
                  placeholder="Text ..."
                  inputRef={(el) =>
                    (annotationRefs.current[`${pageNum}-${index}`] = el)
                  }
                  // readOnly
                  onFocus={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                  }}
                  onBlur={(e) => {
                    setFocusedAnnotation(null);
                    if (isAnnotating) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        setTimeout(() => {
                          if (cursorRef.current) {
                            cursorRef.current.style.display = "block";
                          }
                        }, 100);
                      }
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.cursor = "text";
                    document.body.style.cursor = "text";
                    if (cursorRef.current) {
                      cursorRef.current.style.display = "none";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (isAnnotating && !focusedAnnotation) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "block";
                      }
                    } else if (!isAnnotating) {
                      document.body.style.cursor = "default";
                    }
                  }}
                  sx={{
                    width: "100%",
                    transition: "width 0.1s ease-out",
                    "& .MuiOutlinedInput-root": {
                      fontFamily:
                        annot.fontFamily || "Helvetica, Arial, sans-serif",
                      // fontSize: `${(annot.fontSize || 15) * scale}px`,
                      fontSize: `${Math.max(
                        10,
                        Math.min(72, annot.fontSize || 15)
                      )}px`,
                      color: annot.color || "rgba(0, 0, 0, 0.87)",
                      letterSpacing: annot.letterSpacing || 0,
                      opacity: annot.opacity || 1,
                      backgroundColor:
                        annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                      textAlign: annot.alignment || "left",
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 145, 255, 0.3)",
                      "&:hover": {
                        border: `2px solid ${annot.type.startsWith("signer_")
                          ? annot.borderColor
                          : "rgb(0, 145, 255)"
                          }`,
                      },
                      "& .MuiInputBase-input": {
                        cursor: "pointer",
                        padding: "3px",
                      },
                    },
                  }}
                  InputProps={{
                    style: { padding: 0 },
                    onClick: (e) => e.stopPropagation(), // Prevent click from bubbling
                  }}
                />
              ) : null}
              {annot?.type === "signer_text" ? (
                <>
                  <TextField
                    variant="outlined"
                    value={annot?.text}
                    onChange={(e) =>
                      handleAnnotationTextChange(e, pageNum, index)
                    }
                    placeholder="Text ..."
                    inputRef={(el) =>
                      (annotationRefs.current[`${pageNum}-${index}`] = el)
                    }
                    readOnly
                    onFocus={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onBlur={(e) => {
                      setFocusedAnnotation(null);
                      if (isAnnotating) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          setTimeout(() => {
                            if (cursorRef.current) {
                              cursorRef.current.style.display = "block";
                            }
                          }, 100);
                        }
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.cursor = "text";
                      document.body.style.cursor = "text";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (isAnnotating && !focusedAnnotation) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "block";
                        }
                      } else if (!isAnnotating) {
                        document.body.style.cursor = "default";
                      }
                    }}
                    sx={{
                      width: "100%",
                      transition: "width 0.1s ease-out",
                      "& .MuiOutlinedInput-root": {
                        fontFamily:
                          annot.fontFamily || "Helvetica, Arial, sans-serif",
                        fontSize: `${Math.max(
                          10,
                          Math.min(72, annot.fontSize || 15)
                        )}px`,
                        // fontSize: `${(annot.fontSize || 15) * scale}px`,
                        color: annot.color || "rgba(0, 0, 0, 0.87)",
                        letterSpacing: annot.letterSpacing || 0,
                        opacity: annot.opacity || 1,
                        backgroundColor: getColorWithNewOpacity(
                          getSignerColorById(annot.signerId, signers), // Use signerId to get color
                          annot.isRequired
                        ),
                        border:
                          activeAnnotationId === `${pageNum}-${index}`
                            ? "2px solid rgb(0, 145, 255)"
                            : "1px solid rgba(0, 0, 0, 0.23)",
                        textAlign: annot.alignment || "left",
                        fontWeight: annot.format?.includes("bold")
                          ? "bold"
                          : "normal",
                        fontStyle: annot.format?.includes("italic")
                          ? "italic"
                          : "normal",
                        textDecoration: annot.format?.includes("underline")
                          ? "underline"
                          : "none",
                        // border:
                        //   activeAnnotationId === `${pageNum}-${index}`
                        //     ? "2px solid rgb(0, 145, 255)"
                        //     : "1px solid rgba(0, 145, 255, 0.3)",
                        "&:hover": {
                          border: `2px solid ${annot.type.startsWith("signer_")
                            ? annot.borderColor
                            : "rgb(0, 145, 255)"
                            }`,
                        },
                        "& .MuiInputBase-input": {
                          cursor: "pointer",
                          padding: "3px",
                        },
                      },
                    }}
                    InputProps={{
                      style: { padding: 0 },
                      onClick: (e) => e.stopPropagation(), // Prevent click from bubbling
                    }}
                  />
                </>
              ) : null}

              {annot?.type === "checkmark" && (
                <Box
                  sx={{
                    // width: annot.width || 30,
                    // height: annot.height || 30,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer !important",
                    pointerEvents: "auto",
                    backgroundColor:
                      annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                    border:
                      activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                    "&:hover": {
                      border: "2px solid rgb(0, 145, 255)",
                      cursor: "pointer !important",
                    },
                    "& *": {
                      cursor: "pointer !important",
                      pointerEvents: "auto !important",
                    },
                  }}
                  className="checkbox-annotation"
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   e.preventDefault();
                  //   setAnnotations((prev) => {
                  //     const pageAnnotations = [...(prev[pageNum] || [])];
                  //     pageAnnotations[index] = {
                  //       ...pageAnnotations[index],
                  //       checked: !pageAnnotations[index].checked,
                  //     };
                  //     return {
                  //       ...prev,
                  //       [pageNum]: pageAnnotations,
                  //     };
                  //   });
                  //   setActiveAnnotationId(`${pageNum}-${index}`);
                  // }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    document.body.style.cursor = "pointer";
                    if (cursorRef.current) {
                      cursorRef.current.style.display = "none";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    if (isAnnotating && !focusedAnnotation) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "block";
                      }
                    }
                  }}
                >
                  {annot.checked ? (
                    <CheckBoxIcon
                      sx={{
                        width: "100%",
                        height: "100%",
                        color: "rgb(0, 145, 255)",
                        cursor: "pointer !important",
                        pointerEvents: "auto",
                        "&:hover": {
                          cursor: "pointer !important",
                        },
                      }}
                    />
                  ) : (
                    <CheckBoxOutlineBlankIcon
                      sx={{
                        width: "100%",
                        height: "100%",
                        color: "rgba(0, 0, 0, 0.54)",
                        cursor: "pointer !important",
                        pointerEvents: "auto",
                        "&:hover": {
                          cursor: "pointer !important",
                        },
                      }}
                    />
                  )}
                </Box>
              )}
              {annot?.type === "signer_checkmark" && (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: getColorWithNewOpacity(
                      getSignerColorById(annot.signerId, signers), // Use signerId to get color
                      annot.isRequired
                    ),
                    border:
                      activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                    cursor: "pointer",
                    "&:hover": {
                      border: "2px solid rgb(0, 145, 255)",
                    },
                  }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   setAnnotations((prev) => {
                //     const pageAnnotations = [...(prev[pageNum] || [])];
                //     pageAnnotations[index] = {
                //       ...pageAnnotations[index],
                //       checked: !pageAnnotations[index].checked,
                //     };
                //     return {
                //       ...prev,
                //       [pageNum]: pageAnnotations,
                //     };
                //   });
                //   setActiveAnnotationId(`${pageNum}-${index}`);
                // }}
                >
                  {annot.checked ? (
                    <CheckBoxIcon
                      sx={{
                        width: "100%",
                        height: "100%",
                        color: "rgb(0, 145, 255)",
                      }}
                    />
                  ) : (
                    <CheckBoxOutlineBlankIcon
                      sx={{
                        width: "100%",
                        height: "100%",
                        color: "rgba(0, 0, 0, 0.54)",
                      }}
                    />
                  )}
                </Box>
              )}
              {annot?.type === "date" && (
                <>
                  <Typography
                    variant="outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    sx={{
                      width: "100%",
                      transition: "width 0.1s ease-out",
                      padding: "3px",
                      borderRadius: "4px",

                      fontFamily:
                        annot.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${Math.max(
                        10,
                        Math.min(72, annot.fontSize || 15)
                      )}px`,
                      // fontSize: `${annot.fontSize || 16}px`,
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      color: "rgba(0, 0, 0, 0.87)",
                      backgroundColor: "rgba(0, 247, 255, 0.25)",
                      textAlign: "left",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                      cursor: "pointer !important",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        cursor: "pointer !important",
                      },
                    }}
                  >
                    {annot?.text}
                  </Typography>
                </>
              )}
              {annot?.type === "signer_date" && (
                <>
                  <Typography
                    variant="outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    sx={{
                      width: "100%",
                      transition: "width 0.1s ease-out",
                      padding: "3px",
                      borderRadius: "4px",

                      fontFamily:
                        annot.fontFamily || "Helvetica, Arial, sans-serif",
                      fontSize: `${Math.max(
                        10,
                        Math.min(72, annot.fontSize || 15)
                      )}px`,
                      // fontSize: `${annot.fontSize || 16}px`,
                      fontWeight: annot.format?.includes("bold")
                        ? "bold"
                        : "normal",
                      fontStyle: annot.format?.includes("italic")
                        ? "italic"
                        : "normal",
                      textDecoration: annot.format?.includes("underline")
                        ? "underline"
                        : "none",
                      color: "rgba(0, 0, 0, 0.87)",
                      backgroundColor: getColorWithNewOpacity(
                        getSignerColorById(annot.signerId, signers), // Use signerId to get color
                        annot.isRequired
                      ),
                      textAlign: "left",
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                      cursor: "pointer !important",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",
                        cursor: "pointer !important",
                      },
                    }}
                  >
                    {annot?.text}
                  </Typography>
                </>
              )}
              {annot?.type === "highlight" && (
                <Box
                  sx={{
                    width: pixelWidth,
                    height: pixelHeight,
                    // width: "100%",
                    // height: "100%",
                    backgroundColor:
                      annot.backgroundColor || "rgba(255, 255, 0, 0.3)",
                    border:
                      activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 145, 255, 0.3)",
                    borderRadius: "2px",
                    cursor: "move !important",
                    "&:hover": {
                      border: "2px solid rgb(0, 145, 255)",
                      cursor: "move !important",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                    setActiveAnnotation(`${pageNum}-${index}`);
                  }}
                />
              )}
              {annot?.type === "my_signature" ||
                annot.type === "my_initials" ? (
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                  }}
                  sx={{
                    width: pixelWidth,
                    height: pixelHeight,
                    position: "relative",
                    cursor: "move !important",

                    transition: "all 0.2s ease-out",
                    backgroundColor:
                      annot.backgroundColor || "rgba(0, 247, 255, 0.25)",
                    border:
                      activeAnnotation === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "2px solid rgba(0, 145, 255, 0.5)",
                    borderRadius: "4px",
                    "&:hover": {
                      cursor: "move !important",
                    },
                    "& *": {
                      cursor: "default !important",
                    },
                    // "& .react-rnd-resizable-handle": {
                    //   position: "absolute",
                    //   width: "8px",
                    //   height: "8px",
                    //   backgroundColor: "rgb(0, 145, 255)",
                    //   borderRadius: "50%",
                    //   zIndex: 10,
                    //   transition: "all 0.2s ease-out",
                    //   "&:hover": {
                    //     backgroundColor: "rgb(0, 120, 215)",
                    //     transform: "scale(1.2)",
                    //   },

                    // },
                  }}
                  onBlur={(e) => {
                    setFocusedAnnotation(null);
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    document.body.style.cursor = "default";
                    if (cursorRef.current) {
                      cursorRef.current.style.display = "none";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    if (isAnnotating && !focusedAnnotation) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "block";
                      }
                    }
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // padding: "4px",
                      // overflow: "hidden",
                    }}
                  >
                    {annot.isLoading ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          border: "1px dashed rgba(0, 145, 255, 0.5)",
                          borderRadius: "4px",
                        }}
                      >
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "rgb(0, 145, 255)",
                          }}
                        />
                      </Box>
                    ) : (
                      <img
                        src={annot.imageUrl}
                        alt="annotation"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          pointerEvents: "none",
                          transition: "all 0.2s ease-out",
                          display: "block",
                          cursor: "move !important",
                        }}
                        onMouseEnter={(e) => {
                          document.body.style.cursor = "move";
                          if (cursorRef.current) {
                            cursorRef.current.style.display = "none";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (isAnnotating && !focusedAnnotation) {
                            document.body.style.cursor = "none";
                            if (cursorRef.current) {
                              cursorRef.current.style.display = "block";
                            }
                          } else {
                            document.body.style.cursor = "default";
                          }
                        }}
                      />
                    )}
                  </div>
                </Box>
              ) : null}
              {annot.type === "stamp" && (
                <Box
                  sx={{
                    width: pixelWidth,
                    height: pixelHeight,
                    position: "relative",
                    cursor: "move !important",

                    transition: "all 0.2s ease-out",
                    border:
                      activeAnnotation === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "2px solid rgba(0, 145, 255, 0.5)",
                    borderRadius: "4px",
                    "&:hover": {
                      border: "2px solid rgb(0, 145, 255)",
                      cursor: "move !important",
                    },
                  }}
                >
                  {annot.isLoading ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        border: "1px dashed rgba(0, 145, 255, 0.5)",
                        borderRadius: "4px",
                      }}
                    >
                      <CircularProgress
                        size={24}
                        sx={{
                          color: "rgb(0, 145, 255)",
                        }}
                      />
                    </Box>
                  ) : (
                    <img
                      src={annot.imageUrl}
                      alt="stamp"
                      style={{
                        width: pixelWidth,
                        height: pixelHeight,
                        objectFit: "contain",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </Box>
              )}

              {[
                "signer_initials",
                "signer_initials_text",
                "signer_chooseImgStamp",
                "signer_chooseImgDrivingL",
                "signer_chooseImgPassportPhoto",
              ].includes(annot.type) && (
                  <Box
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    InputProps={{
                      readOnly: true,
                      style: { cursor: "default !important" },
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      document.body.style.cursor = "pointer";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      if (isAnnotating && !focusedAnnotation) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "block";
                        }
                      }
                    }}
                    sx={{
                      width: pixelWidth,
                      height: pixelHeight,
                      position: "relative",
                      cursor: "pointer !important",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      // backgroundColor: `${annot?.signerColor}`,
                      backgroundColor: getColorWithNewOpacity(
                        getSignerColorById(annot.signerId, signers), // Use signerId to get color
                        annot.isRequired
                      ),
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 145, 255, 0.3)",
                      borderRadius: "4px",
                      // gap: 0.5,
                      transition: "all 0.2s ease-out",
                      "&:hover": {
                        border: "2px solid rgb(0, 145, 255)",

                        // backgroundColor: `${selectedSigner?.color}`,
                        cursor: "pointer !important",
                      },
                      "& *": {
                        cursor: "pointer !important",
                        pointerEvents: "auto !important",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        cursor: "pointer !important",
                        pointerEvents: "auto !important",
                      }}
                    >
                      {getSignerBoxContent(annot.type)?.icon}
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "rgba(0, 0, 0, 0.87)",
                        fontSize: "19px",
                        textAlign: "center",
                        cursor: "pointer !important",
                        pointerEvents: "auto !important",
                      }}
                    >
                      {getSignerBoxContent(annot.type)?.text}
                    </Typography>
                  </Box>
                )}
              {annot.type === "signer_dropdown" && (
                <>
                  {/* <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value=""
                  placeholder="Select..."
                  InputProps={{
                    readOnly: true,
                    style: { cursor: "default" },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                  }}
                  onBlur={(e) => {
                    setFocusedAnnotation(null);
                    // if (isAnnotating) {
                    //   document.body.style.cursor = "none";
                    //   if (cursorRef.current) {
                    //     setTimeout(() => {
                    //       if (cursorRef.current) {
                    //         cursorRef.current.style.display = "block";
                    //       }
                    //     }, 100);
                    //   }
                    // }
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    document.body.style.cursor = "default";
                    if (cursorRef.current) {
                      cursorRef.current.style.display = "none";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    if (isAnnotating && !focusedAnnotation) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "block";
                      }
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      // backgroundColor: getColorWithNewOpacity(
                      //   annot.signerColor,
                      //   annot.isRequired
                      // ),
                      backgroundColor: getColorWithNewOpacity(
                        getSignerColorById(annot.signerId, signers), // Use signerId to get color
                        annot.isRequired
                      ),
                      width: annot.width || 150,
                      height: annot.height || 30,
                      cursor: "default !important",
                      "& .MuiSelect-select": {
                        cursor: "default !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        cursor: "default !important",
                      },

                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                      "&:hover": {
                        border: `2px solid ${
                          annot.borderColor || "rgb(0, 145, 255)"
                        }`,
                        cursor: "default !important",
                      },
                      "& *": {
                        cursor: "default !important",
                      },
                    },
                  }}
                /> */}
                  <TextField
                    select
                    fullWidth
                    variant="outlined"
                    value=""
                    placeholder="Select..."
                    InputProps={{
                      readOnly: true,
                      style: { cursor: "default" },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setFocusedAnnotation(`${pageNum}-${index}`);
                      handleAnnotationClick(pageNum, index, annot);
                    }}
                    onBlur={(e) => {
                      setFocusedAnnotation(null);
                      // if (isAnnotating) {
                      //   document.body.style.cursor = "none";
                      //   if (cursorRef.current) {
                      //     setTimeout(() => {
                      //       if (cursorRef.current) {
                      //         cursorRef.current.style.display = "block";
                      //       }
                      //     }, 100);
                      //   }
                      // }
                    }}
                    onMouseEnter={(e) => {
                      e.stopPropagation();
                      document.body.style.cursor = "default";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "none";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      if (isAnnotating && !focusedAnnotation) {
                        document.body.style.cursor = "none";
                        if (cursorRef.current) {
                          cursorRef.current.style.display = "block";
                        }
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        // backgroundColor: getColorWithNewOpacity(
                        //   annot.signerColor,
                        //   annot.isRequired
                        // ),
                        backgroundColor: getColorWithNewOpacity(
                          getSignerColorById(annot.signerId, signers), // Use signerId to get color
                          annot.isRequired
                        ),
                        width: pixelWidth,
                        height: pixelHeight,
                        cursor: "default !important",
                        "& .MuiSelect-select": {
                          cursor: "default !important",
                        },
                        "& .MuiOutlinedInput-input": {
                          cursor: "default !important",
                        },

                        border:
                          activeAnnotationId === `${pageNum}-${index}`
                            ? "2px solid rgb(0, 145, 255)"
                            : "1px solid rgba(0, 0, 0, 0.23)",
                        "&:hover": {
                          border: `2px solid ${annot.borderColor || "rgb(0, 145, 255)"
                            }`,
                          cursor: "default !important",
                        },
                        "& *": {
                          cursor: "default !important",
                        },
                      },
                    }}
                  >
                    {annot.options && annot.options.length > 0 ? (
                      annot.options.map((option, idx) => (
                        <MenuItem key={idx} value={option}>
                          {option}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No options</MenuItem>
                    )}
                  </TextField>
                </>
              )}
              {/* edit  */}
              {EditingTemp ? (
                <>
                  {annot.type === "my_signature" ||
                    annot.type === "stamp" ||
                    annot.type === "my_initials" ? (
                    <IconButton
                      size="small"
                      sx={{
                        position: "absolute",
                        top: "-20px",
                        right: "10px",
                        backgroundColor: "rgb(35, 179, 232)",
                        padding: "3px",
                        zIndex: 1000,
                        cursor: "pointer !important",
                        "&:hover": {
                          backgroundColor: "rgb(2 142 193)", // Darker red on hover
                          cursor: "pointer !important",
                        },
                      }}
                      disableRipple
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          annot.type === "my_signature" ||
                          annot.type === "my_initials"
                        ) {
                          handleEditSignature(pageNum, index, annot);
                        } else if (annot.type === "stamp") {
                          handleEditStamp(pageNum, index, annot);
                        }
                      }}
                      onMouseDown={(e) => e.stopPropagation()} // Prevent drag events
                      onMouseUp={(e) => e.stopPropagation()}
                    >
                      <EditIcon
                        sx={{
                          color: "white",
                          fontSize: "15px",
                          pointerEvents: "none",
                        }}
                      />
                    </IconButton>
                  ) : null}
                  {/* delete  */}
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      right: "-15px",
                      backgroundColor: "red",
                      padding: "3px",
                      zIndex: 1000,
                      cursor: "pointer !important",
                      "&:hover": {
                        backgroundColor: "#d32f2f", // Darker red on hover
                        cursor: "pointer !important",
                      },
                    }}
                    disableRipple
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteAnnotation(pageNum, index);
                    }}
                    onMouseDown={(e) => e.stopPropagation()} // Prevent drag events
                    onMouseUp={(e) => e.stopPropagation()}
                  >
                    <CloseIcon
                      sx={{
                        color: "white",
                        fontSize: "15px",
                        pointerEvents: "none",
                      }}
                    />
                  </IconButton>
                </>
              ) : (
                <></>
              )}
            </Box>
          </Rnd>
        );
      });
    },
    [annotations, isAnnotating, focusedAnnotation, scale, isInteracting]
  );

  // Add a class to the main container when annotation mode is active
  const mainContainerClass = isAnnotating ? "custom-cursor" : "";

  const cursorConfig = useMemo(() => {
    return {
      my_text: { type: "image", image: "/text.png", width: 130, height: 33 },
      my_signature: {
        type: "image",
        image: "/signature11.png",
        width: 250,
        height: 100,
      },
      my_initials: {
        type: "image",
        image: "/initial.png",
        width: 100,
        height: 100,
      },
      date: { type: "image", image: "/date.png", width: 120, height: 30 },
      checkmark: { type: "image", image: "/check.png", width: 30, height: 30 },
      highlight: {
        type: "image",
        image: "/highlight.png",
        width: 120,
        height: 30,
      },
      stamp: { type: "image", image: "/stamp.png", width: 150, height: 150 },

      signer_initials: {
        type: "imageWithBackground",

        // type: "image",
        image: "/signer_signature.png",
        width: 250,
        height: 100,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_text: {
        type: "imageWithBackground",

        // type: "image",
        image: "/signer_text.png",
        width: 70,
        height: 33,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_initials_text: {
        type: "imageWithBackground",
        image: "/signer_initial.png",
        width: 100,
        height: 100,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_checkmark: {
        type: "imageWithBackground",
        image: "/signer_check.png",
        width: 30,
        height: 30,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_date: {
        type: "imageWithBackground",
        image: "/signer_date.png",
        width: 120,
        height: 30,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_chooseImgStamp: {
        type: "imageWithBackground",
        image: "/signer_stamp.png",
        width: 150,
        height: 150,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_chooseImgDrivingL: {
        type: "imageWithBackground",
        image: "/signer_driving_license.png",
        width: 350,
        height: 200,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_chooseImgPassportPhoto: {
        type: "imageWithBackground",
        image: "/signer_passport_photo.png",
        width: 450,
        height: 299,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
      signer_dropdown: {
        type: "imageWithBackground",
        image: "/signer_dropdown.png",
        width: 110,
        height: 27,
        backgroundColor: selectedSigner.color, // Background color for the image
      },
    };
    // For Other - Box based
    // signer_initials: { type: "box", color: "#f0f0f0" },
    // signer_initials_text: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgStamp: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgDrivingL: { type: "box", color: "#f0f0f0" },
    // signer_chooseImgPassportPhoto: { type: "box", color: "#f0f0f0" },
    // signer_checkmark: { type: "box", color: "#f0f0f0" },
    // signer_text: { type: "box", color: "#f0f0f0" },
    // signer_dropdown: { type: "box", color: "#f0f0f0" },
  }, [selectedSigner]);

  useEffect(() => {
    if (isAnnotating) {
      // const cursorConfigItem =
      //   cursorConfig[annotationType] || cursorConfig["stamp"];
      const cursorConfigItem =
        cursorConfig[annotationType] || cursorConfig["stamp"];
      if (cursorRef.current) {
        document.body.removeChild(cursorRef.current);
        cursorRef.current = null;
      }
      // if (cursorConfigItem.type === "imageWithBackground") {
      //   // Create container with background
      //   const cursorElement = document.createElement("div");
      //   cursorElement.classList.add("custom-cursor-image-with-bg");

      //   // Set container styles with background
      //   Object.assign(cursorElement.style, {
      //     width: `${cursorConfigItem.width}px`,
      //     height: `${cursorConfigItem.height}px`,
      //     backgroundColor:
      //       cursorConfigItem.backgroundColor || "rgba(255, 255, 255, 0.8)",
      //     border: cursorConfigItem.border || "1px solid rgba(0, 0, 0, 0.2)",
      //     borderRadius: "4px",
      //     position: "fixed",
      //     zIndex: 9999,
      //     pointerEvents: "none",
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     padding: "0", // Ensure no padding
      //     overflow: "hidden", // Prevent image overflow
      //     boxSizing: "border-box",
      //   });

      //   // Create the image inside the container
      //   const imageElement = document.createElement("img");
      //   imageElement.src = cursorConfigItem.image;
      //   imageElement.style.width = "100%"; // Slightly smaller than container
      //   imageElement.style.height = "100%";
      //   imageElement.style.objectFit = "contain";

      //   cursorElement.appendChild(imageElement);
      //   document.body.appendChild(cursorElement);
      //   cursorRef.current = cursorElement;
      // }
      if (cursorConfigItem.type === "imageWithBackground") {
        // Create container with background
        const cursorElement = document.createElement("div");
        cursorElement.classList.add("custom-cursor-image-with-bg");

        // Set container styles with background - improved version for full fill
        Object.assign(cursorElement.style, {
          width: `${cursorConfigItem.width}px`,
          height: `${cursorConfigItem.height}px`,
          backgroundColor: selectedSigner
            ? selectedSigner.color
            : "rgba(255, 255, 255, 0.8)",

          borderRadius: "2px", // Reduced border radius
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0",
          overflow: "hidden", // Prevent image overflow
          boxSizing: "border-box", // Include border in size calculation
          border: "none", // Remove border completely
          boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2)", // Optional: subtle shadow instead of border
        });

        // Create the image inside the container
        const imageElement = document.createElement("img");
        imageElement.src = cursorConfigItem.image;
        imageElement.style.width = "100%"; // Make image slightly smaller for better visual appearance
        imageElement.style.height = "100%";
        imageElement.style.objectFit = "contain";
        imageElement.style.opacity = "1"; // Full opacity for the image

        cursorElement.appendChild(imageElement);
        document.body.appendChild(cursorElement);
        cursorRef.current = cursorElement;
      } else if (cursorConfigItem.type === "image") {
        // ---- IMAGE Cursor ----
        const cursorElement = document.createElement("div");
        cursorElement.classList.add("custom-cursor-image");
        cursorElement.style.width = `${cursorConfigItem.width}px`;
        cursorElement.style.height = `${cursorConfigItem.height}px`;
        cursorElement.style.backgroundImage = `url(${cursorConfigItem.image})`;
        document.body.appendChild(cursorElement);
        cursorRef.current = cursorElement;
      } else if (cursorConfigItem.type === "box") {
        // ---- BOX Cursor ----
        const boxElement = document.createElement("div");
        boxElement.classList.add("custom-cursor-box");
        document.body.appendChild(boxElement);
        cursorRef.current = boxElement;
        const calculatedWidth = calculateTextWidth(
          "Text ....",
          16,
          "Helvetica"
        );
        // Dynamic size map
        const sizeMap = {
          signer_initials: { width: "250px", height: "74px" },
          signer_initials_text: { width: "100px", height: "74px" },
          signer_chooseImgStamp: { width: "150px", height: "100px" },
          signer_chooseImgDrivingL: { width: "350px", height: "120px" },
          signer_chooseImgPassportPhoto: { width: "450px", height: "170px" },
          signer_checkmark: { width: "30px", height: "30px" },
          signer_date: { width: "120px", height: "25px" },
          signer_text: { width: calculatedWidth, height: "27px" },
          signer_dropdown: { width: "120px", height: "25px" },
        };

        const { width, height } = sizeMap[annotationType] || {
          width: "120px",
          height: "50px",
        };

        const getPaddingTop = (type) => {
          switch (type) {
            case "signer_chooseImgDrivingL":
              return "78px";
            case "signer_chooseImgPassportPhoto":
              return "128px";
            case "signer_checkmark":
              return "0px";
            case "signer_initials":
            case "signer_initials_text":
            // case "signer_chooseImgStamp":
            case "signer_chooseImgDrivingL":
            case "signer_chooseImgPassportPhoto":
              return "25px";
            case "signer_chooseImgStamp":
              return "50px";
            default:
              return "2px";
          }
        };

        Object.assign(boxElement.style, {
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          paddingTop: getPaddingTop(annotationType),
          width,
          height,
          // backgroundColor: selectedSigner.color,
          backgroundColor:
            cursorConfigItem.backgroundColor || "rgba(255, 255, 255, 0.8)",

          // padding: annotationType === "signer_checkmark" ? "5px" : null,
          border: "1px solid rgba(0,0,0,0.2)",
          opacity: 0.6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Arial",
          fontWeight: "bold",
          color: "#000",
          borderRadius: "4px",
          // padding: annotationType === "signer_checkmark" ? "5px" : "0px",
        });

        // Dynamic content rendering per type
        if (annotationType === "signer_checkmark") {
          // boxElement.innerHTML = `
          //   <div style="width: 20px; height: 20px; border: 2px solid black; background-color: white;margin:2px"></div>
          // `;
          boxElement.innerHTML = `
        <div style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${selectedSigner.color};
            border-radius: 4px;
            box-sizing: border-box;
            /* This is the padding behind the checkbox */
        ">
            <div style="
                width: 20px;
                height: 20px;
                background-color: white;
                border: 2px solid black;
                box-sizing: border-box;
            "></div>
        </div>
    `;
        } else if (annotationType === "signer_date") {
          // boxElement.innerHTML = `
          //   <div style="font-size: 16px; font-weight: 400;padding-left:2px;">Date</div>
          // `;
          boxElement.innerHTML = `
          <div style="
            font-size: 16px;
            font-weight: 400;
            padding-left: 2px;
            padding-right: 2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            height: 100%;
          ">
            Date...
            <div style="
              position: absolute;
              bottom: 2px;
              left: 0;
              width: calc(100% - 4px); 
              height: 1px;
              background-color: black;
            "></div>
          </div>
        `;
        } else if (annotationType === "signer_text") {
          boxElement.innerHTML = `
            <div style="font-size: 18px; font-weight: 400; padding-left:4px;padding-top:2px;text-decoration: none;">Text ...</div>
          `;
        } else if (annotationType === "signer_dropdown") {
          boxElement.innerHTML = `
            <div style="font-size: 18px; font-weight: 400; padding-left:4px;padding-top:2px;text-decoration: none;">Dropdown ...</div>
          `;
        } else {
          const boxContent = getSignerBoxContentSvg(annotationType);
          if (boxContent) {
            boxElement.innerHTML = `
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                ${boxContent.icon}
                <div style="font-size: 21px; font-weight: 400;">${boxContent.text}</div>
              </div>
            `;
          }
        }
      }

      const moveCursor = (e) => {
        const target = e.target;
        // 1. Check if we're on a scrollbar
        const isScrollbar = (element) => {
          if (!element || !element.classList) return false;

          if (element.classList.contains("pdf-container")) {
            const rect = element.getBoundingClientRect();
            // Detect vertical scrollbar
            if (
              element.scrollHeight > element.clientHeight &&
              e.clientX > rect.right - 17
            ) {
              return true;
            }
            // Detect horizontal scrollbar
            if (
              element.scrollWidth > element.clientWidth &&
              e.clientY > rect.bottom - 17
            ) {
              return true;
            }
          }
          return false;
        };
        if (isResizing) {
          cursorRef.current.style.display = "none";
          // document.body.style.cursor = "default";
          // document.body.style.cursor = window.getComputedStyle(target).cursor;
          return;
        }
        if (target.closest(".react-rnd-resizable-handle")) {
          cursorRef.current.style.display = "none";
          document.body.style.cursor = window.getComputedStyle(target).cursor;
          return;
        }
        // Check for all cases where we should hide custom cursor
        const shouldHideCustomCursor =
          // Text fields
          target.tagName === "INPUT" ||
          target.closest(".MuiTextField-root") ||
          // Annotations
          target.closest(".annotation") ||
          // Resize handles
          // target.closest(".react-rnd-resizable-handle") ||
          // Edit/Delete buttons
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]') ||
          // Sidebars
          target.closest(".left-sidebar") ||
          target.closest(".right-sidebar") ||
          target.closest(".zoom-container");

        // Check if we're in the PDF container
        const isPdfContainer = target.closest(".pdf-container");

        if (shouldHideCustomCursor) {
          // Hide custom cursor
          cursorRef.current.style.display = "none";
          document.body.style.cursor = getCursorForElement(target);
          // Set appropriate cursor style
          // if (target.closest(".react-rnd-resizable-handle")) {
          //   document.body.style.cursor = "nw-resize";
          // } else
          if (target.classList.contains("annotation-resize-handle")) {
            cursorRef.current.style.display = "none"; // Hide your custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return;
          }
          if (target.closest(".react-rnd-resizable-handle")) {
            cursorRef.current.style.display = "none"; // Hide custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return; // Let Rnd's default cursor handling work
          }
          if (
            target.closest(".MuiIconButton-root") ||
            target.closest('[aria-label="edit"]') ||
            target.closest('[aria-label="close"]')
          ) {
            document.body.style.cursor = "pointer";
          } else if (target.closest(".annotation")) {
            document.body.style.cursor = "move";
          } else if (
            target.tagName === "INPUT" ||
            target.closest(".MuiTextField-root")
          ) {
            document.body.style.cursor = "text";
          } else {
            document.body.style.cursor = "default";
          }
        } else if (isPdfContainer) {
          // Show custom cursor only in PDF container and not over any special elements
          cursorRef.current.style.display = "block";
          cursorRef.current.style.left = `${e.clientX}px`;
          cursorRef.current.style.top = `${e.clientY}px`;
          document.body.style.cursor = "none";
        } else {
          // Hide custom cursor outside PDF container
          cursorRef.current.style.display = "none";
          document.body.style.cursor = "default";
        }
      };

      const getCursorForElement = (target) => {
        if (target.closest(".react-resizable-handle"))
          return window.getComputedStyle(target).cursor;
        if (
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]')
        ) {
          return "pointer";
        }
        if (target.closest(".annotation")) return "move";
        if (target.tagName === "INPUT" || target.closest(".MuiTextField-root"))
          return "text";
        return "default";
      };

      document.addEventListener("mousemove", moveCursor);

      return () => {
        document.removeEventListener("mousemove", moveCursor);
        if (cursorRef.current?.parentNode) {
          document.body.removeChild(cursorRef.current);
          cursorRef.current = null;
        }
        document.body.style.cursor = "default";
      };
    }
  }, [isAnnotating, annotationType, selectedSigner]);

  const cursorTypes = {
    my_text: {
      className: "custom-cursor-image",
      imageUrl: "/public/text.png",
      width: "150px",
      height: "30px",
    },
    highlight: {
      className: "custom-cursor-image-highlight",
      imageUrl: "/public/highlight.png",
      width: "150px",
      height: "30px",
    },
    stamp: {
      className: "custom-cursor-image-stamp",
      imageUrl: "/public/stamp.png",
      width: "150px",
      height: "150px",
    },
    my_signature: {
      className: "custom-cursor-image-signature",
      imageUrl: "/public/signature11.png",
      width: "250px",
      height: "100px",
    },
    my_initials: {
      className: "custom-cursor-image-initials",
      imageUrl: "/public/initial.png",
      width: "100px",
      height: "100px",
    },
    checkmark: {
      className: "custom-cursor-image-check",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    date: {
      className: "custom-cursor-image-date",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    signer_text: {
      className: "custom-cursor-image-signer-text",
      imageUrl: "/public/text.png",
      width: "150px",
      height: "30px",
    },
    signer_initials: {
      className: "custom-cursor-image-signer-signature",
      imageUrl: "/public/signature11.png",
      width: "250px",
      height: "100px",
    },
    signer_initials_text: {
      className: "custom-cursor-image-signer-initials",
      imageUrl: "/public/initial.png",
      width: "100px",
      height: "100px",
    },
    signer_date: {
      className: "custom-cursor-image-signer-date",
      imageUrl: "/public/date.png",
      width: "30px",
      height: "30px",
    },
    signer_checkmark: {
      className: "custom-cursor-image-signer-check",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    signer_chooseImgStamp: {
      className: "custom-cursor-image-signer-stamp",
      imageUrl: "/public/stamp.png",
      width: "150px",
      height: "150px",
    },
  };

  // In your App component
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadOriginal = async () => {
    // const pdfUrl = apiData?.result[0]?.image;
    if (!originalPdf) return;

    setIsDownloading(true);
    try {
      const success = await downloadOriginalPdf(originalPdf, fileName);
      if (!success) {
        toastAlert("error", "Failed to download PDF");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toastAlert("error", "Failed to download PDF");
    } finally {
      setIsDownloading(false);
    }
  };
  const handleSaveAndGoBack = async () => {
    // Save template without validation - allow empty annotations
    try {
      setIsSaving(true);
      await saveDataTemplat(documentId, annotations);
      toastAlert("success", "Template saved successfully!");
      // Small delay to show success message, then navigate back
      setTimeout(() => {
        window.location.href = `${FrontendBaseUrl}template`;
      }, 500);
    } catch (error) {
      console.error("Error saving template:", error);
      toastAlert("error", "Failed to save template");
      setIsSaving(false);
    }
  };

  const onCallBackTemplateFinish = async () => {
    console.log("adadda");
    console.log(signers);
    if (signers.length === 0) {
      toastAlert("error", "Please add signers before proceeding");
      setSignersDialogOpen(true);
      return;
    }
    // also check signer name should be present if not present show error
    if (signers.some((signer) => signer.name === "")) {
      // alert("Please fill all fields.");
      toastAlert("error", "Please fill all fields");
      // setSignerAddEdit(true);
      setSignersDialogOpen(true);
      return;
    }
    const allAnnotations = Object.entries(annotations).reduce(
      (acc, [pageNum, pageAnnotations]) => {
        return acc.concat(pageAnnotations);
      },
      []
    );
    const signerWithoutField = signers.find(
      (signer) =>
        !allAnnotations.some(
          (annot) =>
            annot.signerId === signer.signer_id ||
            annot.signer_id === signer.signer_id
        )
    );

    if (signerWithoutField) {
      toastAlert(
        "error",
        `Please add at least one field for signer: ${signerWithoutField.name || signerWithoutField.email || "Unknown"
        }`
      );
      return;
    }
    setSendTemplateModalConfirmation(true);
    console.log("added dgdg");
  };
  const [isMobileDialogOpen, setIsMobileDialogOpen] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 780) {
      setIsMobileDialogOpen(true);
    }
  }, []);
  // hashed ids

  useEffect(() => {
    // Track page size changes using ResizeObserver
    const resizeObserver = new ResizeObserver((entries) => {
      // Update page sizes when observed elements change size
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    });

    // Observe all PDF pages
    pdfImages.forEach((_, pageIndex) => {
      const pageElement = document.getElementById(`img-${pageIndex + 1}`);
      if (pageElement) {
        resizeObserver.observe(pageElement);
      }
    });

    return () => resizeObserver.disconnect();
  }, [pdfImages]);

  // Add this useEffect after your existing effects
  useEffect(() => {
    const handleResize = debounce(() => {
      // Force re-render of annotations when screen size changes
      setAnnotations((prev) => ({ ...prev }));
      // setAnnotations((prev) => {
      //   const updated = { ...prev };
      //   // Add a timestamp to force re-render without changing data
      //   updated._lastUpdate = Date.now();
      //   return updated;
      // });
      // Force re-render by updating state properly
      // setAnnotations((prev) => {
      //   // Ensure we're working with valid annotation structure
      //   const validAnnotations = {};

      //   Object.keys(prev).forEach((pageNum) => {
      //     if (Array.isArray(prev[pageNum])) {
      //       validAnnotations[pageNum] = [...prev[pageNum]];
      //     } else if (pageNum !== "_lastUpdate") {
      //       // Reset invalid page annotations to empty array
      //       validAnnotations[pageNum] = [];
      //     }
      //   });

      //   // Add timestamp for re-render
      //   validAnnotations._lastUpdate = Date.now();

      //   return validAnnotations;
      // });
    }, 100);

    const handleZoom = debounce(() => {
      // Detect zoom changes and recalculate
      const currentZoom = window.devicePixelRatio;
      if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
        window.lastZoom = currentZoom;
        // setAnnotations((prev) => {
        //   const updated = { ...prev };
        //   updated._lastUpdate = Date.now();
        //   return updated;
        // });
        setAnnotations((prev) => ({ ...prev }));
      }
      // if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
      //   window.lastZoom = currentZoom;

      //   setAnnotations((prev) => {
      //     // Same validation as above
      //     const validAnnotations = {};

      //     Object.keys(prev).forEach((pageNum) => {
      //       if (Array.isArray(prev[pageNum])) {
      //         validAnnotations[pageNum] = [...prev[pageNum]];
      //       } else if (pageNum !== "_lastUpdate") {
      //         validAnnotations[pageNum] = [];
      //       }
      //     });

      //     validAnnotations._lastUpdate = Date.now();
      //     return validAnnotations;
      //   });
      // }
    }, 100);

    window.addEventListener("resize", handleResize);
    window.addEventListener("wheel", handleZoom, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("wheel", handleZoom);
    };
  }, []);
  // Add this right after your state declarations, before any useEffects

  // Replace your existing resize effect with this improved version:

  // Add this function after your existing functions
  // Add this useEffect after your existing ones
  useEffect(() => {
    if (pdfImages.length > 0 && pdfContainerRef.current) {
      // Auto-fit PDF to container on initial load
      const timeoutId = setTimeout(() => {
        const container = pdfContainerRef.current;
        const firstPage = container?.querySelector(".pdf-page-container");

        if (firstPage && container) {
          const containerWidth = container.offsetWidth;
          const pageWidth = firstPage.scrollWidth;

          // If PDF is much smaller than container, increase scale slightly
          if (pageWidth < containerWidth * 0.7) {
            const newScale = Math.min(1.2, (containerWidth * 0.9) / pageWidth);
            setScale(newScale);
          }
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [pdfImages]);

  // Add this enhanced scale effect
  useEffect(() => {
    const handleScaleChange = debounce(() => {
      // Detect if the PDF container size has changed significantly
      const container = pdfContainerRef.current;
      if (!container) return;

      const newContainerWidth = container.offsetWidth;
      const widthDifference = Math.abs(newContainerWidth - containerWidth);

      // Only trigger recalculation if change is significant (more than 50px)
      if (widthDifference > 50) {
        setContainerWidth(newContainerWidth);

        // Force annotation recalculation
        setTimeout(() => {
          setAnnotations((prev) => {
            const updated = { ...prev };
            updated._lastUpdate = Date.now();
            return updated;
          });
        }, 100); // Small delay to ensure PDF has rendered
      }
    }, 200);

    // Use ResizeObserver for more accurate container size tracking
    const resizeObserver = new ResizeObserver(handleScaleChange);

    if (pdfContainerRef.current) {
      resizeObserver.observe(pdfContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerWidth]);
  return (
    <>
      {isLoading && <FullScreenLoader />}
      {showTour && isReadyForTour && EditingTemp && (
        <EsignEditorTour
          forceStart={showTour}
          onClose={() => setShowTour(false)}
          screen={false}
        />
      )}
      <Box className={mainContainerClass}>
        {/* Add this near the end of your return statement, alongside other modals */}
        <Dialog
          open={isMobileDialogOpen}
        // onClose={() => setIsMobileDialogOpen(false)}
        >
          <DialogTitle>Notice</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              This screen is only editable on laptops or desktop computers.
              Mobile view is not supported for editing.
            </Typography>
          </DialogContent>
        </Dialog>
        <input
          type="file"
          ref={stampInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleStampFileSelect} // Remove lastClickPosition parameter
        />
        <FileUpload
          showTour={showTour}
          setShowTour={setShowTour}
          logo={logo}
          primaryColorComp={primaryColorComp}
          sendEsignModalOpenTemp={sendEsignModalOpenTemp}
          setSendEsignModalOpenTemp={(state) =>
            setSendEsignModalOpenTemp(state)
          }
          user={user}
          EditingTemp={EditingTemp}
          templateDoc={true}
          setFileName={(name) => setFileName(name)}
          emailSubject={emailSubject}
          setEmailSubject={setEmailSubject}
          emailMessage={emailMessage}
          setEmailMessage={setEmailMessage}
          originalPdf={originalPdf}
          uniqIdDoc={uniqIdDoc}
          user_email={user_email}
          file_id={documentId}
          annotations={annotations}
          signers={signers}
          setSigners={setSigners}
          user_id={userId}
          file_name={fileName || "Document"}
          // pdfUrl="https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/112316_riazirim22%2F20241106%2F0019_Invoice-2C6D4BDF-0024.pdf" // Add your PDF URL here
          onDownloadOriginal={handleDownloadOriginal}
          isDownloading={isDownloading}
          onCallBackTemplateFinish={() => {
            if (signers.length === 0) {
              toastAlert("error", "Please add signers before proceeding");
              setSignersDialogOpen(true);
              return;
            }
            // also check signer name should be present if not present show error
            if (signers.some((signer) => signer.name === "")) {
              // alert("Please fill all fields.");
              toastAlert("error", "Please fill all fields");
              // setSignerAddEdit(true);
              setSignersDialogOpen(true);
              return;
            }
            const allAnnotations = Object.entries(annotations).reduce(
              (acc, [pageNum, pageAnnotations]) => {
                return acc.concat(pageAnnotations);
              },
              []
            );
            const signerWithoutField = signers.find(
              (signer) =>
                !allAnnotations.some(
                  (annot) =>
                    annot.signerId === signer.signer_id ||
                    annot.signer_id === signer.signer_id
                )
            );

            if (signerWithoutField) {
              toastAlert(
                "error",
                `Please add at least one field for signer: ${signerWithoutField.name ||
                signerWithoutField.email ||
                "Unknown"
                }`
              );
              return;
            }
            setSendTemplateModalConfirmation(true);
            console.log("added dgdg");
          }}
        />

        {!pdfFile ? (
          <></>
        ) : (
          <>
            {window.innerWidth < 760 ? (
              <Grid2 container spacing={0} height="90vh">
                {/* Main PDF Viewer */}
                <Grid2 xs={12} className="main-container">
                  <Grid2
                    item
                    // className="pdf-container"
                    className={`pdf-container ${isAnnotating ? "custom-cursor" : ""
                      }`}
                    ref={pdfContainerRef}
                    onClick={handlePdfClick} // Enable click for annotations if in annotation mode
                  >
                    <Box
                      className="pdf-content-box"
                      sx={{
                        minWidth:
                          scale > 1
                            ? `${100 * scale}%`
                            : `${calculateImageWidth(scale)}%`,
                        maxWidth: scale > 1 ? `${100 * scale}%` : "100%",
                        position: "relative",
                        // overflow: scale > 1 ? "auto" : "hidden",
                        // minWidth: `${calculateImageWidth(scale)}%`,
                        alignContent: scale <= 1 ? "center" : "flex-start",
                        justifyContent: scale <= 1 ? "center" : "flex-start",
                        alignItems: scale <= 1 ? "center" : "flex-start",
                        display: scale <= 1 ? "flex" : "block",

                        transformOrigin: "top left",
                      }}
                    >
                      {pdfImages.length > 0 ? (
                        pdfImages.map((image, index) => (
                          <div
                            key={index}
                            className="pdf-page-container"
                            id={`img-${index + 1}`}
                            onMouseEnter={() => handlePageHover(index + 1)}
                            style={{
                              width: `${calculateImageWidth(scale)}%`,
                              position: "relative",
                            }} // Ensure relative positioning
                          >
                            {renderImage(image, index)}
                            {/* Pass the page number directly */}
                            {renderAnnotations(index + 1)}
                          </div>
                        ))
                      ) : (
                        <Typography>Loading PDF...</Typography>
                      )}
                    </Box>
                  </Grid2>
                </Grid2>
              </Grid2>
            ) : (
              <Grid2 container spacing={0} height="90vh">
                {/* Left Sidebar */}
                <Grid2
                  item
                  xs={2}
                  ref={sidebarRef}
                  sx={styles.sidebarStyle}
                  onMouseDown={(e) => e.stopPropagation()}
                  onMouseUp={(e) => e.stopPropagation()}
                  className="left-sidebar"
                >
                  {/* <Button
                style={{ width: "100%" }}
                onClick={downloadPdfWithAnnotations}
              >
                Download
              </Button> */}
                  <Button
                    variant="contained"
                    component="span"
                    onClick={async () => {
                      console.log("editihngtemp", EditingTemp);
                      if (EditingTemp === true) {
                        // Show nice modal instead of window.confirm
                        setSaveConfirmModalOpen(true);
                      } else {
                        window.location.href = `${FrontendBaseUrl}template`;
                      }
                    }}
                    sx={{
                      textTransform: "none",
                      color: "white",
                      width: "100%",
                      cursor: "pointer !important",
                      fontWeight: 600,
                      backgroundColor:
                        primaryColorComp === null ||
                          primaryColorComp === undefined
                          ? colortheme
                          : primaryColorComp,
                      // marginLeft: "20px",
                      boxShadow: "none",
                      marginBottom: "10px",

                      position: "relative", // Add this for loader positioning
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor:
                          primaryColorComp === null ||
                            primaryColorComp === undefined
                            ? colortheme
                            : primaryColorComp,
                        cursor: "pointer !important",
                      },
                      "&.Mui-disabled": {
                        backgroundColor:
                          primaryColorComp === null ||
                            primaryColorComp === undefined
                            ? colortheme
                            : primaryColorComp,
                        color: "white",
                      },
                    }}
                  >
                    Back
                  </Button>
                  {EditingTemp ? (
                    <Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Button
                          className="manage-signers-btn"
                          onClick={() => setSignersDialogOpen(true)}
                          // startIcon={<AddIcon />}
                          variant="contained"
                          component="span"
                          sx={{
                            width: "100%",
                            backgroundColor: "#28c76f",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: "#17aa59",
                              boxShadow: "none",
                            },
                            textTransform: "none",
                            marginBottom: "20px",
                            // px: 3,
                          }}
                        >
                          Signers
                        </Button>

                        {signers.length > 0 && active === "2" && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              mb: 2,
                            }}
                          >
                            <FormControl fullWidth>
                              <Select
                                value={selectedSignerId || ""}
                                onChange={(e) => {
                                  setSelectedSignerId(e.target.value);
                                  setSelectedSigner(e.target.value);
                                }}
                                sx={{
                                  height: "40px",
                                  "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    padding: "5px 14px",
                                    minHeight: "0px !important",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)",
                                  },
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      "& .MuiMenuItem-root": {
                                        minHeight: "35px",
                                        padding: "4px 14px",
                                      },
                                    },
                                  },
                                }}
                              >
                                {signers.map((signer, index) => (
                                  <MenuItem
                                    key={index}
                                    value={signer}
                                    onClick={() => {
                                      setSelectedSignerId(signer);
                                      setSelectedSigner(signer);
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: 1,
                                      pr: 1,
                                      backgroundColor:
                                        selectedSignerId?.signer_id ===
                                          signer.signer_id
                                          ? "rgba(0, 145, 255, 0.08)"
                                          : "transparent",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 20,
                                          height: 20,
                                          borderRadius: "50%",
                                          backgroundColor: signer.color,
                                          flexShrink: 0,
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          maxWidth: "120px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {signer.name === ""
                                          ? truncateName(signer.placeholder)
                                          : truncateName(signer.name)}
                                        {/* {truncateName(signer.name)} */}
                                      </Typography>
                                    </Box>
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        )}
                      </Box>
                      <Box className="zoom-container esign-toolbar">
                        <Box hidden={active !== "2"}>
                          <ForOthers
                            type={getTypeListItem}
                            typeData={annotationType}
                            selectedSigner={selectedSigner}
                          />
                        </Box>
                      </Box>
                      {/* end  */}
                      <Box
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {annotationType ? (
                          <>
                            <Button
                              onClick={() => {
                                setSelectedAnnotation(null);
                                setAnnotationType(null);
                                setIsAnnotating(false);
                              }}
                              variant="contained"
                              component="span"
                              sx={{
                                width: "100%",
                                boxShadow: "none",
                                backgroundColor: "#ea5455",
                                "&:hover": {
                                  backgroundColor: "#d32524",
                                  boxShadow: "none",
                                },
                                textTransform: "none",
                                // px: 3,
                              }}
                            >
                              Deselect
                            </Button>
                          </>
                        ) : null}
                      </Box>
                    </Box>
                  ) : null}
                </Grid2>
                {/* Main PDF Viewer */}
                <Grid2 xs={8} className="main-container esign-document-canvas">
                  <Grid2
                    item
                    // className="pdf-container"
                    className={`pdf-container ${isAnnotating ? "custom-cursor" : ""
                      }`}
                    ref={pdfContainerRef}
                    onClick={handlePdfClick} // Enable click for annotations if in annotation mode
                    sx={{
                      height: "100%", // Use full height
                      overflow: "auto",
                      display: "flex",
                      justifyContent: "center",
                      padding: "10px", // Reduce padding
                    }}
                  >
                    <Box
                      className="pdf-content-box"
                      sx={{
                        width: "100%", // Use full width of container
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        minHeight: "100%",
                        // Remove transform-related properties that might interfere
                        transformOrigin: "top center",
                      }}
                    >
                      {pdfImages.length > 0 ? (
                        pdfImages.map((image, index) => (
                          <div
                            key={index}
                            className="pdf-page-container"
                            id={`img-${index + 1}`}
                            onMouseEnter={() => handlePageHover(index + 1)}
                            style={{
                              width: `${calculateImageWidth(scale)}%`,
                              maxWidth: scale > 1 ? "none" : "100%", // Remove max-width limit when zoomed
                              minWidth: "300px", // Reduce minimum width
                              position: "relative",
                              margin: "0 auto",
                              marginBottom: "20px",
                              // Ensure the PDF uses available height efficiently
                              display: "flex",
                              flexDirection: "column",
                            }} // Ensure relative positioning
                          >
                            <img
                              src={image}
                              alt={`Page ${index + 1}`}
                              className="pdf-image"
                              style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                                objectFit: "contain",
                                // Remove any height restrictions
                                maxHeight: "none",
                              }}
                            />
                            {renderAnnotations(index + 1)}
                          </div>
                        ))
                      ) : (
                        <Typography>Loading PDF...</Typography>
                      )}
                    </Box>
                  </Grid2>
                </Grid2>
                {/* Right Sidebar */}
                <Grid2
                  item
                  xs={2}
                  className="right-sidebar esign-page-preview"
                  ref={sidebarRef}
                  sx={styles.sidebarStyle}
                >
                  {EditingTemp ? (
                    <>
                      {/* start  */}
                      {selectedAnnotation &&
                        (selectedAnnotation?.type === "my_text" ||
                          selectedAnnotation?.type === "signer_text") && (
                          <>
                            <TextPropertiesPanel
                              closeButton={() => {
                                setSelectedAnnotation(null);
                                setAnnotationType(null);
                                setIsAnnotating(false);
                              }}
                              type={annotationType}
                              selectedAnnotation={selectedAnnotation}
                              onUpdateAnnotation={handleUpdateAnnotation}
                              setTextFieldMetrics={setTextFieldMetrics}
                              setAnnotationSettings={setAnnotationSettings}
                              scale={scale}
                            />
                          </>
                        )}
                      {selectedAnnotation?.type === "signer_dropdown" && (
                        <DropdownPropertiesPanel
                          selectedAnnotation={selectedAnnotation}
                          onUpdateAnnotation={handleUpdateAnnotation}
                          closeButton={() => {
                            setSelectedAnnotation(null);
                            setAnnotationType(null);
                            setIsAnnotating(false);
                          }}
                        />
                      )}
                      {(selectedAnnotation?.type === "signer_initials" ||
                        selectedAnnotation?.type === "signer_initials_text" ||
                        selectedAnnotation?.type === "signer_chooseImgStamp" ||
                        selectedAnnotation?.type ===
                        "signer_chooseImgDrivingL" ||
                        // selectedAnnotation?.type === "signer_checkmark" ||
                        selectedAnnotation?.type ===
                        "signer_chooseImgPassportPhoto") && (
                          <SignerFieldProperties
                            selectedAnnotation={selectedAnnotation}
                            onUpdateAnnotation={handleUpdateAnnotation}
                            closeButton={() => {
                              setSelectedAnnotation(null);
                              setAnnotationType(null);
                              setIsAnnotating(false);
                            }}
                          />
                        )}
                      {selectedAnnotation &&
                        (selectedAnnotation.type === "date" ||
                          selectedAnnotation.type === "signer_date") && (
                          <DatePickerComponent
                            selectedAnnotation={selectedAnnotation}
                            onUpdateAnnotation={handleUpdateAnnotation}
                            type={selectedAnnotation.type}
                            closeButton={() => {
                              setSelectedAnnotation(null);
                              setAnnotationType(null);
                              setIsAnnotating(false);
                            }}
                          />
                        )}
                    </>
                  ) : null}
                  {/* end  */}
                  {EditingTemp ? (
                    <>
                      {(!selectedAnnotation?.type?.startsWith("signer_") ||
                        selectedAnnotation?.type === "signer_checkmark") &&
                        selectedAnnotation?.type !== "my_text" &&
                        selectedAnnotation?.type !== "date" && (
                          <>
                            <Typography variant="h6">Preview</Typography>
                            {pdfImages.length > 0 &&
                              pdfImages.map((image, index) => (
                                <>
                                  <Box
                                    key={index}
                                    sx={{
                                      scrollMarginTop: "8px",
                                      scrollMarginBottom: "8px",
                                      transition: "all 0.1s ease",
                                    }}
                                    id={`thumbnail-${index + 1}`}
                                    className={`thumbnail-container ${activePage === index + 1 ? "active" : ""
                                      }`}
                                    onClick={() => {
                                      document
                                        .getElementById(`img-${index + 1}`)
                                        .scrollIntoView({ behavior: "smooth" });
                                      setActivePage(index + 1);
                                    }}
                                  >
                                    {renderImage(image, index, false)}
                                  </Box>
                                  <p
                                    className={`page-number ${activePage === index + 1 ? "active" : ""
                                      }`}
                                  >
                                    Page {index + 1}
                                  </p>
                                </>
                              ))}{" "}
                          </>
                        )}
                    </>
                  ) : (
                    <>
                      <Typography variant="h6">Preview</Typography>
                      {pdfImages.length > 0 &&
                        pdfImages.map((image, index) => (
                          <>
                            <Box
                              key={index}
                              sx={{
                                scrollMarginTop: "8px",
                                scrollMarginBottom: "8px",
                                transition: "all 0.1s ease",
                              }}
                              id={`thumbnail-${index + 1}`}
                              className={`thumbnail-container ${activePage === index + 1 ? "active" : ""
                                }`}
                              onClick={() => {
                                document
                                  .getElementById(`img-${index + 1}`)
                                  .scrollIntoView({ behavior: "smooth" });
                                setActivePage(index + 1);
                              }}
                            >
                              {renderImage(image, index, false)}
                            </Box>
                            <p
                              className={`page-number ${activePage === index + 1 ? "active" : ""
                                }`}
                            >
                              Page {index + 1}
                            </p>
                          </>
                        ))}{" "}
                    </>
                  )}
                </Grid2>{" "}
              </Grid2>
            )}
          </>
        )}
        {signatureModalOpen && (
          <Dialog
            open={signatureModalOpen}
            onClose={() => {
              console.log("close mic ");
              setSignatureModalOpen(false);
              setAnnotations((prev) => {
                const pageAnnotations = prev[activePage] || [];
                return {
                  ...prev,
                  [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                };
              });
            }}
            maxWidth="md"
            fullWidth
          >
            <SignatureModalContent
              initialsBox={initialsBox}
              primaryColorComp={primaryColorComp}
              profile={false}
              returnedSignature={handleSignatureComplete}
              modalClosingD={() => {
                setSignatureModalOpen(false);
                console.log("close meet");
                setAnnotations((prev) => {
                  const pageAnnotations = prev[activePage] || [];
                  return {
                    ...prev,
                    [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                  };
                });
              }}
              modalClose={() => {
                setSignatureModalOpen(false);
                console.log("close m");
                // setAnnotations((prev) => {
                //   const pageAnnotations = prev[activePage] || [];
                //   return {
                //     ...prev,
                //     [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                //   };
                // });
              }}
              user_id_user={userId} // Replace with actual user ID if needed
              user_email="rimshanimo22@gmail.com"
            />
          </Dialog>
        )}
      </Box>
      {/* // Add this instead (place it next to your other Dialog components): */}
      <Dialog
        open={cropperModalOpen}
        onClose={() => {
          setCropperModalOpen(false);
          setCropSrc(null);
          setPendingStampAction(null);
          setStampClickPosition(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Crop Image
          {/* <IconButton
            aria-label="close"
            onClick={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton> */}
        </DialogTitle>
        <DialogContent>
          <ImageCropperModal
            cropSrc={cropSrc}
            isOpen={cropperModalOpen}
            toggle={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            onImageCropped={handleCroppedStamp}
          />
        </DialogContent>
      </Dialog>
      {/* // Add the SignersDialog component in your return statement (near other dialogs) */}
      <SignersDialogTemplate
        primaryColorComp={primaryColorComp}
        EditingTemp={EditingTemp}
        annotations={annotations}
        templateDoc={true}
        setAnnotationsd={async (newAnnotations) => {
          console.log("Updating annotations:", newAnnotations);
          setAnnotations(newAnnotations);
          await saveDataTemplat(documentId, newAnnotations);
        }}
        open={signersDialogOpen}
        onClose={() => {
          setSignersDialogOpen(false);
          setSignerToEdit(null); // Clear edit state on close
        }}
        signers={signers}
        file_id={documentId}
        setSigners={setSigners}
        signerToEdit={signerToEdit}
      />

      {/* <ConfirmationDialog
        open={SendTemplateModalConfirmation}
        onClose={() => {
          if (!loading1) {
            setSendTemplateModalConfirmation(false);
          }
        }}
        loading={loading1}
        // longTextState={longText}
        onConfirm={handleConfirm1}
        title="Confirm Action"
        description="Are you sure you want to complete this template document?"
        alertStatus="warning" // or 'delete' based on your use case
        // detailedDescription="Please note that all items placed for the signers will be removed and cannot be undone. Do you wish to proceed?"
        // longText={`Please note that all items placed for the signers will be removed and cannot be undone.Do you wish to proceed?`}
      /> */}
      <Dialog
        open={SendTemplateModalConfirmation}
        onClose={() => {
          setSendTemplateModalConfirmation(false);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            pb: 2,
            flexShrink: 0,
            backgroundColor: "#f8f9fa",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Save Template
          </Typography>
          <IconButton
            onClick={() => {
              setSendTemplateModalConfirmation(false);
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2, flex: 1, minHeight: 0, overflow: "auto" }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ mb: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, color: "rgba(0, 0, 0, 0.6)" }}
              >
                Email Subject
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={emailSubject}
                error={!emailSubject?.trim()}
                helperText={!emailSubject?.trim() ? "Subject is required" : ""}
                onChange={(e) => setEmailSubject(e.target.value)}
                sx={{ mb: 3 }}
              />

              <Typography
                variant="subtitle2"
                sx={{ mb: 1, color: "rgba(0, 0, 0, 0.6)" }}
              >
                Email Message
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={8}
                value={emailMessage}
                onChange={(e) => setEmailMessage(e.target.value)}
                sx={{ mb: 2 }}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            flexShrink: 0,
            display: "flex",
            justifyContent: "flex-end",
            px: 3,
            py: 2,
            m: 0,
            borderTop: "1px solid rgba(0,0,0,0.12)",
            backgroundColor: "rgba(0,0,0,0.02)",
          }}
        >
          <Button
            disabled={loading1}
            onClick={async (e) => {
              if (!emailSubject?.trim()) {
                toastAlert("error", "Email subject is required");
                return;
              }
              setLoading1(true);
              try {
                await sendToEsignApi();
              } catch (error) {
                console.error("Error sending document:", error);
                toastAlert("error", "Failed to send document");
              } finally {
                setLoading1(false);
              }
            }}
            variant="contained"
            sx={{
              backgroundColor:
                primaryColorComp === null || primaryColorComp === undefined
                  ? "#21b3e8"
                  : primaryColorComp,
              boxShadow: "none",
              "&:hover": {
                backgroundColor:
                  primaryColorComp === null || primaryColorComp === undefined
                    ? "#00bcff"
                    : primaryColorComp,
                boxShadow: "none",
              },
              px: 4,
            }}
          >
            {loading1 ? (
              <>
                <CircularProgress
                  size={24}
                  sx={{
                    color: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
                <span style={{ opacity: 0 }}>Save</span>
              </>
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Save Confirmation Modal */}
      <Dialog
        open={saveConfirmModalOpen}
        onClose={() => {
          if (!isSaving) {
            setSaveConfirmModalOpen(false);
          }
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            pb: 2,
            backgroundColor: "#f8f9fa",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Save Changes
          </Typography>
          <IconButton
            onClick={() => {
              if (!isSaving) {
                setSaveConfirmModalOpen(false);
              }
            }}
            size="small"
            disabled={isSaving}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2, pb: 1 }}>
          <Typography variant="body1" sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
            Do you want to save the previous changes before going back?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            pt: 1,
            gap: 1,
          }}
        >
          <Button
            onClick={() => {
              setSaveConfirmModalOpen(false);
            }}
            variant="outlined"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setSaveConfirmModalOpen(false);
              window.location.href = `${FrontendBaseUrl}template`;
            }}
            variant="outlined"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
              color: "#d32f2f",
              borderColor: "#d32f2f",
              "&:hover": {
                borderColor: "#b71c1c",
                backgroundColor: "rgba(211, 47, 47, 0.04)",
              },
            }}
          >
            Cancel & Don't Save
          </Button>
          <Button
            onClick={async () => {
              try {
                await handleSaveAndGoBack();
                // handleSaveAndGoBack already navigates, but close modal just in case
                setSaveConfirmModalOpen(false);
              } catch (error) {
                console.error("Error saving:", error);
                setIsSaving(false);
              }
            }}
            variant="contained"
            disabled={isSaving}
            sx={{
              textTransform: "none",
              minWidth: 100,
              backgroundColor:
                primaryColorComp === null || primaryColorComp === undefined
                  ? "#21b3e8"
                  : primaryColorComp,
              boxShadow: "none",
              "&:hover": {
                backgroundColor:
                  primaryColorComp === null || primaryColorComp === undefined
                    ? "#00bcff"
                    : primaryColorComp,
                boxShadow: "none",
              },
            }}
          >
            {isSaving ? (
              <>
                <CircularProgress
                  size={20}
                  sx={{
                    color: "white",
                    marginRight: 1,
                  }}
                />
                Saving...
              </>
            ) : (
              "Save & Go Back"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EsignSetupTemplate;
